<template>
  <div class="cat-new">
    <b-row>
      <b-col cols="12">
        <h4>Cổng thông tin iTel
        </h4>
      </b-col>
    </b-row>
    <!-- search input -->
    <section id="knowledge-base-search">
      <div class="text-center">
        <b-row>
          <b-col md="7" sm="7" xs="12">
            <b-tabs>
              <b-tab active title="Tra cứu thông tin" @click="changeTab(1)">
              </b-tab>
              <b-tab title="Hot news" @click="changeTab(2)">
              </b-tab>
              <b-tab title="Vinh danh nhân viên CSKH" @click="changeTab(3)">
              </b-tab>
              <b-tab title="Thông báo" @click="changeTab(4)">
              </b-tab>
            </b-tabs>
          </b-col>
          <b-col class="text-right" md="5" sm="5" xs="12">
            <b-row>
              <b-col md="4" sm="4" xs="12">
              </b-col>
              <b-col cols="8" md="8" sm="8" xs="12">
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon"/>
                  </b-input-group-prepend>
                  <b-form-input id="searchbar" v-model="searchQuery" class="search-new"
                                placeholder="Nhập nội dung tìm kiếm" v-on:keydown.enter="quickSearch"/>
                </b-input-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="tabActive == 1" class="content-cat">
          <b-col md="4" sm="6" xs="12">
            <b-row>
              <b-col md="7" sm="6" xs="12">
                <div class="title-cat">Danh mục</div>
              </b-col>
              <b-col md="5" sm="6" xs="12">
                <div class="title-cat">Chủ đề</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="mt-1 cat-sub" cols="7" md="7" sm="6" xs="12">
                <b-card class="text-center" no-body>
                  <b-card-body>
                    <span v-for="(f, stt) in categoryList" :key="stt">
                      <b-row v-b-toggle="'collapse-' + f.id" :aria-controls="'collapse-' + f.id"
                             :aria-expanded="f.isShow == true ? 'true' : 'false'" class="tree-item">
                        <b-col class="parent-item" md="10" sm="10" xs="10">
                          <label class="tree-item-text">{{ f.name }}</label>
                        </b-col>
                        <b-col md="2" sm="2" xs="2">
                          <div :class="f.isShow ? 'bt-tonggle-expand' : 'bt-tonggle-collspan'">
                            <div class="icon-img"></div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-collapse :id="'collapse-' + f.id" v-model="f.isShow">
                        <b-row v-for="(v, stt2) in f.children" :key="stt2" class="tree-item-chi"
                               @click="clickTreeItem(v.id)">
                          <b-col :class="v.id == item_active_id ? 'item-chi-active' : ''" md="9" sm="9" xs="9">
                            <label class="tree-item-text-chi">{{ v.name }}</label>
                          </b-col>
                          <b-col md="2" sm="2" xs="2">
                          </b-col>
                        </b-row>
                      </b-collapse>
                    </span>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col class="mt-1 cat-sub" cols="5" md="5" sm="6" xs="12">
                <b-row>
                  <b-card class="text-left" no-body>
                    <b-card-body>
                      <b-row v-for="(v, stt2) in listNews" v-if="listNews.length > 0" :key="stt2" class="item-sub"
                             v-bind:class="{ 'item-sub-active': isSelected(v.id) }">
                        <b-col class="div-item-text">
                          <label class="item-sub-text" v-on:click="detailClick(v)">{{ v.Index }}. {{ v.name }}
                          </label>
                        </b-col>

                      </b-row>
                      <b-row v-else-if="this.searchQuery || this.item_active_id > 0">
                        Không có chủ đề nào thỏa mãn tìm kiếm
                      </b-row>
                      <!-- <b-list-group class="list-group-circle " v-if="listNews.length > 0">
                        <b-list-group-item v-for="item in listNews" :key="item.id"
                          class="list-group-item text-body item-new"
                          v-bind:class="{ 'group-item-active': isSelected(item.id) }" v-on:click="detailClick(item)">
                          {{ item.Index }}. {{ item.name }}
                        </b-list-group-item>
                      </b-list-group> -->

                    </b-card-body>
                  </b-card>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="new-detail" cols="8" md="8" sm="6" xs="12">
            <b-card class="text-left" no-body>
              <b-card-body>
                <div v-if="Object.keys(currentItem).length > 0">
                  <b-row class="text-right">
                    <b-col md="9" sm="6" xs="12"></b-col>
                    <b-col class="header-status" md="3" sm="4" xs="4">
                      <b-form-group>
                        <label>Trạng thái: </label>
                        <label :class="currentItem.status == 1 ? 'status-1' : 'status-2'" class="ml-50">
                          {{ currentItem.statusName }}</label>
                      </b-form-group>
                      <div class="hr-bottom"></div>
                    </b-col>
                  </b-row>
                  <b-row class="detail-tile">
                    {{ currentItem.catName }} &#62; {{ currentItem.topicName }} &#62; {{ currentItem.name }}
                  </b-row>
                  <b-row class="use-new">
                    <b-col cols="12">
                      <b-form-group>
                        <!-- eslint-disable vue/no-v-html -->
                        <div class="question-content" v-html="currentItem.contents"/>
                        <!-- eslint-enable -->
                      </b-form-group>
                    </b-col>
                    <b-col v-if="currentItem.file_path && currentItem.file_path.length > 0" cols="12">
                      <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                                     @click="downloadFile(currentItem.file_path)">
                        <div class="sample-file__download">
                          <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                        </div>
                        {{ currentItem.file_path.split('/')[1] }}
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row class="text-right">
                    <b-col md="8" sm="6" xs="12">
                      <b-form-group>
                        <label>Ngày tạo: </label>
                        <label class="ml-50">
                          <b>{{this.dateFormat(currentItem.created_date) }}</b></label>
                      </b-form-group>

                    </b-col>
                    <b-col md="4" sm="6" xs="12">
                      <b-form-group>
                        <label>Người soạn: </label>
                        <label class="ml-50">
                          <b>{{ currentItem.created_at }}</b></label>
                      </b-form-group>
                      <div class="mt-1">&nbsp;</div>
                    </b-col>
                  </b-row>
                  <b-row class="text-right">
                    <b-col md="8" sm="6" xs="12">
                      <b-form-group>
                        <label>Ngày sửa: </label>
                        <label class="ml-50">
                          <b>{{this.dateFormat(currentItem.updated_date) }}</b></label>
                      </b-form-group>

                    </b-col>
                    <b-col v-if="currentItem.updated_at" md="4" sm="6" xs="12">
                      <b-form-group>
                        <label>Người sửa: </label>
                        <label class="ml-50">
                          <b>{{ currentItem.updated_at }}</b></label>
                      </b-form-group>
                      <div class="mt-1">&nbsp;</div>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="tabActive == 2" class="content-cat">
          <b-col cols="12">
            <vue-good-table :columns="options.fields" :fixed-header="true" :isLoading.sync="isLoading" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [20, 50, 100], dropdownAllowAll: false }"
                            :rows="listHotNews" :totalRows="totalRecordHot" mode="remote"
                            styleClass="vgt-table striped"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                  <span style="font-weight: bold; color: blue; cursor: pointer; line-height: 30px;"
                        @click="detailModalShow(props.row)">{{ props.row.name }}</span>
                </span>
                <span v-else-if="props.column.field == 'topic_name'">
                  {{ props.row.originalIndex + 1 }}. {{ props.row.topic_name }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
        <b-row v-if="tabActive == 3" class="content-cat">
          <b-col class="cat-sub" md="2" sm="4" xs="12">
            <b-card class="text-center" no-body>
              <b-card-body>
                  <span v-for="(f, stt) in categoryHonors" :key="stt">
                    <b-row v-b-toggle="'collapse-' + f.id" :aria-controls="'collapse-' + f.id"
                           :aria-expanded="f.isShow == true ? 'true' : 'false'" class="tree-item">
                      <b-col class="parent-item" md="10" sm="10" xs="10">
                        <label class="tree-item-text">{{ f.name }}</label>
                      </b-col>
                      <b-col md="2" sm="2" xs="2">
                        <div :class="f.isShow ? 'bt-tonggle-expand' : 'bt-tonggle-collspan'">
                          <div class="icon-img"></div>
                        </div>
                      </b-col>
                    </b-row>
                    <b-collapse :id="'collapse-' + f.id" v-model="f.isShow">
                      <b-row v-for="(v, stt2) in f.children" :key="stt2" class="tree-item-chi"
                             @click="clickTreeItemHonors(v.id)">
                        <b-col :class="v.id == item_active_id ? 'item-chi-active' : ''" md="9" sm="9" xs="9">
                          <label class="tree-item-text-chi">{{ v.name }}</label>
                        </b-col>
                        <b-col md="2" sm="2" xs="2">
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </span>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col class="new-detail" cols="10" md="10" sm="8" xs="12">
            <b-card class="text-left" no-body>
              <b-card-body>
                <div class="honors-row">
                  <div v-for="(f, stt) in listHonors" :key="stt" class="honors-item">
                    <div class="honors-item-content">
                      <div class="prize">
                        {{ f.type_prize }}
                      </div>
                      <div class="img-path">
                        <img :src="f.image_path?f.image_path:'/img/6-small.c9b47a98.png'">
                      </div>
                      <div class="full-name">
                        {{ f.full_name }}
                      </div>
                      <div class="channel">
                        {{ f.channel }}
                      </div>
                      <div class="point">
                        {{ f.point }} điểm
                      </div>
                      <div class="parner">
                        {{ f.parner }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="tabActive == 4" class="content-cat">
          <b-col cols="12">
            <vue-good-table :columns="options.fieldNotice" :fixed-header="true" :isLoading.sync="isLoading"
                            :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [20, 50, 100], dropdownAllowAll: false }"
                            :rows="listNotices" :totalRows="totalNotices" mode="remote"
                            styleClass="vgt-table striped"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                  <span style="font-weight: bold; color: blue; cursor: pointer; line-height: 30px;"
                        @click="detailNoticeShow(props.row)">{{ props.row.name }}</span>
                </span>
                <span v-else-if="props.column.field == 'name'">
                  {{ props.row.originalIndex + 1 }}. {{ props.row.name }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </div>
    </section>
    <b-modal id="modal-hot-new" hide-footer hide-header no-close-on-backdrop no-close-on-esc size="xl" title="">
      <b-row class="hot-new-content-popup">
        <b-col md="12" sm="12" xs="12">
          <div v-if="totalRecordHot == 0">
            <b-form-group class="text-center no-data">
              <label>Hôm nay không có gì Hot cả.</label>
              <br>
              <label> Chúc bạn một ngày làm việc vui vẻ nhé!</label>
            </b-form-group>
          </div>
          <div v-else class="content-cat">
            <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [50, 100], dropdownAllowAll: false }" :rows="listHotNews"
                            :totalRows="totalRecordHot" max-height="420px" mode="remote"
                            styleClass="vgt-table striped"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                  <span v-title="props.row.contents"
                        :style="[props.row.isRead ? { opacity: 0.5 } : { opacity: 1 }]"
                        style="font-weight: bold; color: blue; cursor: pointer; line-height: 30px;"
                        @click="detailModalShow(props.row)">{{ props.row.name }}</span>
                </span>
                <span v-else-if="props.column.field == 'topic_name'">
                  {{ props.row.originalIndex + 1 }}. {{ props.row.topic_name }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
          <div class="mt-50" style="height: 40px">&nbsp;</div>
          <div class="clearfix"></div>
        </b-col>
        <b-col class="text-center  mt-50" cols="12">
          <b-button class="btn-sm mr-50 btn-confirm" variant="primary" @click="confirm()">
            <i class="fa confirm-custom">
              <svg fill="none" height="18" viewBox="0 0 27 18" width="27"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6811 6.00804L11.7122 10.4351L8.39189 8.14858C7.95405 7.85669 7.26081 7.85669 6.85945 8.12425C6.42162 8.41615 6.42162 8.87831 6.82297 9.14587L10.9095 11.9432C11.1284 12.0891 11.4203 12.1621 11.6757 12.1621C11.9311 12.1621 12.223 12.0891 12.4419 11.9675L20.2135 7.05398C20.6513 6.78642 20.6878 6.32425 20.25 6.03236C19.8122 5.74047 19.1189 5.74047 18.6811 6.00804Z"
                    fill="url(#paint0_linear_253_9)"/>
                <path
                    d="M13.5 0C6.05676 0 0 4.03784 0 9C0 13.9622 6.05676 18 13.5 18C20.9432 18 27 13.9622 27 9C27 4.03784 20.9432 0 13.5 0ZM13.5 16.5405C7.26081 16.5405 2.18919 13.1595 2.18919 9C2.18919 4.84054 7.26081 1.45946 13.5 1.45946C19.7392 1.45946 24.8108 4.84054 24.8108 9C24.8108 13.1595 19.7392 16.5405 13.5 16.5405Z"
                    fill="url(#paint1_linear_253_9)"/>
                <defs>
                  <linearGradient id="paint0_linear_253_9" gradientUnits="userSpaceOnUse" x1="13.5435" x2="13.5435" y1="5.74593"
                                  y2="12.5581">
                    <stop stop-color="white"/>
                    <stop offset="1" stop-color="#00ACEA"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_253_9" gradientUnits="userSpaceOnUse" x1="13.5" x2="13.5" y1="-0.182432"
                                  y2="19.1223">
                    <stop stop-color="white"/>
                    <stop offset="1" stop-color="#00ACEA"/>
                  </linearGradient>
                </defs>
              </svg>
            </i>
            Xác nhận đã nhận thông tin
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-confirm-sucess" centered hide-footer hide-header no-close-on-backdrop no-close-on-esc title="">
      <div>
        <svg fill="none" height="169" viewBox="0 0 687 169" width="687" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M49 29C49 17.9543 57.9543 9 69 9H667C678.046 9 687 17.9543 687 29V149C687 160.046 678.046 169 667 169H69C57.9543 169 49 160.046 49 149V29Z"
              fill="#FFAC60"/>
          <g filter="url(#filter0_d_253_9)">
            <path
                d="M162.837 76.0468C167.149 68.006 314.196 86.8051 331.335 78.9433C348.473 71.0814 280.46 39.8823 305.898 30.1171C331.335 20.3518 420.635 23.7447 420.635 30.1171C420.635 36.4894 395.706 68.0169 420.635 78.9433C445.564 89.8697 579.03 76.0468 567.304 84.6535C555.578 93.2601 591.201 141.06 585.344 146.638C579.488 152.216 179.982 138.312 162.837 146.638C145.692 154.963 148.479 102.816 162.837 76.0468Z"
                fill="white" stroke="#FFAC60"/>
            <g filter="url(#filter1_d_253_9)">
              <path
                  d="M360.5 39H364.5C369.194 39 373 42.8056 373 47.5C373 52.1944 369.194 56 364.5 56H360.5C355.806 56 352 52.1944 352 47.5C352 42.8056 355.806 39 360.5 39Z"
                  fill="#FF5A5A"/>
              <path
                  d="M360.5 39H364.5C369.194 39 373 42.8056 373 47.5C373 52.1944 369.194 56 364.5 56H360.5C355.806 56 352 52.1944 352 47.5C352 42.8056 355.806 39 360.5 39Z"
                  stroke="#FFAC60"/>
            </g>
          </g>
          <path
              d="M229.538 104H233.93V103.424L231.95 103.154H231.518L229.538 103.424V104ZM230.636 104H231.626L235.46 97.79L235.748 97.268H235.856L235.352 96.908L230.636 104ZM236.144 104H242.156V103.424L239.618 103.154H238.88L236.144 103.424V104ZM236.378 97.016L240.518 90.68H239.582L236.234 96.224L235.946 96.71H235.856L236.378 97.016ZM238.376 104H241.184L233.39 90.68H230.582L238.376 104ZM229.718 91.274L232.238 91.508H233.048L235.622 91.274V90.68H229.718V91.274ZM237.35 91.274L239.258 91.508H239.708L241.67 91.274V90.68H237.35V91.274ZM247.692 89.348L247.962 89.726C248.934 89.312 249.906 88.88 250.86 88.43C251.742 88.034 251.976 87.602 251.976 87.26C251.976 86.846 251.616 86.432 251.112 86.432C250.716 86.432 250.374 86.63 249.78 87.224C249.114 87.872 248.412 88.61 247.692 89.348ZM242.634 104H246.702V103.424L244.758 103.172H244.416L242.634 103.424V104ZM243.876 104H244.776L248.412 92.444L248.466 92.192H248.088L251.886 104H254.496L249.924 90.608H248.358L243.876 104ZM245.874 99.662H251.832L251.706 99.068H246L245.874 99.662ZM249.798 104H255.648V103.406L253.146 103.154H252.228L249.798 103.406V104ZM263.15 104.342C264.77 104.342 266.03 103.982 267.164 103.298L267.128 100.184H266.156L265.22 103.73L266.48 103.316V102.668C265.49 103.388 264.626 103.676 263.6 103.676C260.9 103.676 258.884 101.66 258.884 97.358C258.884 93.074 260.9 91.004 263.582 91.004C264.644 91.004 265.436 91.292 266.372 91.94V91.346L265.076 90.914L266.03 94.496H267.002L267.038 91.364C265.868 90.698 264.77 90.338 263.168 90.338C259.28 90.338 256.184 92.804 256.184 97.448C256.184 102.02 259.19 104.342 263.15 104.342ZM273.161 104H278.021V103.424L275.555 103.154H275.051L273.161 103.424V104ZM274.907 104H275.771V99.32L275.573 91.166H274.907V104ZM281.639 91.274L284.141 91.508H284.609L286.499 91.274V90.68H281.639V91.274ZM283.421 104.072H284.735V90.68H283.979V95.918L284.051 101.264L284.393 101.138L277.211 90.68H273.215V91.274L274.727 91.4L275.321 92.318L275.375 92.372L283.421 104.072ZM287.824 104H293.746V103.424L290.992 103.154H290.488L287.824 103.424V104ZM289.48 104H292.144C292.09 101.93 292.09 99.842 292.09 97.43V96.926C292.09 94.82 292.09 92.714 292.144 90.68H289.48C289.516 92.75 289.516 94.82 289.516 96.926V97.772C289.516 99.878 289.516 101.984 289.48 104ZM290.812 97.502H298.768V96.854H290.812V97.502ZM295.816 104H301.756V103.424L299.038 103.154H298.552L295.816 103.424V104ZM297.418 104H300.1C300.046 101.93 300.046 99.842 300.046 97.772V96.926C300.046 94.82 300.046 92.714 300.1 90.68H297.418C297.49 92.75 297.49 94.82 297.49 96.926V97.43C297.49 99.878 297.49 101.984 297.418 104ZM287.824 91.274L290.488 91.508H290.992L293.746 91.274V90.68H287.824V91.274ZM295.816 91.274L298.552 91.508H299.038L301.756 91.274V90.68H295.816V91.274ZM309.788 86.702H308.744L305.954 89.618L306.224 89.978L309.986 87.944H308.546L312.29 89.978L312.578 89.618L309.788 86.702ZM302.822 104H306.926V103.424L304.946 103.172H304.622L302.822 103.424V104ZM304.082 104H304.964L308.672 91.706L308.15 92.228L311.93 104H314.54L309.986 90.608H308.42L304.082 104ZM305.972 99.662H312.092L311.912 99.05H306.17L305.972 99.662ZM309.968 104H315.818V103.424L313.316 103.154H312.398L309.968 103.424V104ZM308.924 108.158C309.68 108.158 310.31 107.618 310.31 106.844C310.31 106.106 309.68 105.566 308.924 105.566C308.168 105.566 307.556 106.106 307.556 106.844C307.556 107.618 308.168 108.158 308.924 108.158ZM316.666 104H321.526V103.424L319.06 103.154H318.556L316.666 103.424V104ZM318.412 104H319.276V99.32L319.078 91.166H318.412V104ZM325.144 91.274L327.646 91.508H328.114L330.004 91.274V90.68H325.144V91.274ZM326.926 104.072H328.24V90.68H327.484V95.918L327.556 101.264L327.898 101.138L320.716 90.68H316.72V91.274L318.232 91.4L318.826 92.318L318.88 92.372L326.926 104.072ZM338.202 104H344.628V103.424L341.73 103.154H341.028L338.202 103.424V104ZM340.074 104H342.738C342.684 101.93 342.684 99.842 342.684 97.772V96.926C342.684 94.82 342.684 92.714 342.738 90.68H340.074C340.128 92.75 340.128 94.82 340.128 96.926V97.772C340.128 99.878 340.128 101.984 340.074 104ZM335.556 94.406H336.528L337.464 90.68L336.24 91.364H346.554L345.348 90.68L346.32 94.406H347.256L347.166 90.68H335.664L335.556 94.406ZM348.486 104H354.408V103.424L351.654 103.154H351.15L348.486 103.424V104ZM350.142 104H352.806C352.752 101.93 352.752 99.842 352.752 97.43V96.926C352.752 94.82 352.752 92.714 352.806 90.68H350.142C350.178 92.75 350.178 94.82 350.178 96.926V97.772C350.178 99.878 350.178 101.984 350.142 104ZM351.474 97.502H359.43V96.854H351.474V97.502ZM356.478 104H362.418V103.424L359.7 103.154H359.214L356.478 103.424V104ZM358.08 104H360.762C360.708 101.93 360.708 99.842 360.708 97.772V96.926C360.708 94.82 360.708 92.714 360.762 90.68H358.08C358.152 92.75 358.152 94.82 358.152 96.926V97.43C358.152 99.878 358.152 101.984 358.08 104ZM348.486 91.274L351.15 91.508H351.654L354.408 91.274V90.68H348.486V91.274ZM356.478 91.274L359.214 91.508H359.7L362.418 91.274V90.68H356.478V91.274ZM371.404 89.33C370.702 88.592 369.946 87.872 369.28 87.224C368.686 86.63 368.362 86.432 367.966 86.432C367.462 86.432 367.084 86.846 367.084 87.26C367.084 87.62 367.354 88.052 368.236 88.448C369.208 88.88 370.162 89.312 371.134 89.708L371.404 89.33ZM363.466 104H367.534V103.424L365.59 103.172H365.248L363.466 103.424V104ZM364.708 104H365.608L369.244 92.444L369.298 92.192H368.92L372.718 104H375.328L370.756 90.608H369.19L364.708 104ZM366.706 99.662H372.664L372.538 99.068H366.832L366.706 99.662ZM370.63 104H376.48V103.406L373.978 103.154H373.06L370.63 103.406V104ZM377.329 104H382.189V103.424L379.723 103.154H379.219L377.329 103.424V104ZM379.075 104H379.939V99.32L379.741 91.166H379.075V104ZM385.807 91.274L388.309 91.508H388.777L390.667 91.274V90.68H385.807V91.274ZM387.589 104.072H388.903V90.68H388.147V95.918L388.219 101.264L388.561 101.138L381.379 90.68H377.383V91.274L378.895 91.4L379.489 92.318L379.543 92.372L387.589 104.072ZM391.992 104H397.914V103.424L395.16 103.154H394.656L391.992 103.424V104ZM393.648 104H396.312C396.258 101.93 396.258 99.842 396.258 97.43V96.926C396.258 94.82 396.258 92.714 396.312 90.68H393.648C393.684 92.75 393.684 94.82 393.684 96.926V97.772C393.684 99.878 393.684 101.984 393.648 104ZM394.98 97.502H402.936V96.854H394.98V97.502ZM399.984 104H405.924V103.424L403.206 103.154H402.72L399.984 103.424V104ZM401.586 104H404.268C404.214 101.93 404.214 99.842 404.214 97.772V96.926C404.214 94.82 404.214 92.714 404.268 90.68H401.586C401.658 92.75 401.658 94.82 401.658 96.926V97.43C401.658 99.878 401.658 101.984 401.586 104ZM391.992 91.274L394.656 91.508H395.16L397.914 91.274V90.68H391.992V91.274ZM399.984 91.274L402.72 91.508H403.206L405.924 91.274V90.68H399.984V91.274ZM419.05 104.342C420.67 104.342 421.93 103.982 423.064 103.298L423.028 100.184H422.056L421.12 103.73L422.38 103.316V102.668C421.39 103.388 420.526 103.676 419.5 103.676C416.8 103.676 414.784 101.66 414.784 97.358C414.784 93.074 416.8 91.004 419.482 91.004C420.544 91.004 421.336 91.292 422.272 91.94V91.346L420.976 90.914L421.93 94.496H422.902L422.938 91.364C421.768 90.698 420.67 90.338 419.068 90.338C415.18 90.338 412.084 92.804 412.084 97.448C412.084 102.02 415.09 104.342 419.05 104.342ZM431.367 86.594H430.341L427.533 89.546L427.821 89.888L431.583 87.872H430.143L433.887 89.888L434.175 89.546L431.367 86.594ZM430.845 104.342C434.193 104.342 437.055 101.876 437.055 97.34C437.055 92.786 434.175 90.338 430.845 90.338C427.533 90.338 424.635 92.822 424.635 97.34C424.635 101.912 427.533 104.342 430.845 104.342ZM430.845 103.676C428.469 103.676 427.317 100.94 427.317 97.34C427.317 93.758 428.469 91.004 430.845 91.004C433.239 91.004 434.373 93.758 434.373 97.34C434.373 100.94 433.239 103.676 430.845 103.676ZM438.342 104H443.202V103.424L440.736 103.154H440.232L438.342 103.424V104ZM440.088 104H440.952V99.32L440.754 91.166H440.088V104ZM446.82 91.274L449.322 91.508H449.79L451.68 91.274V90.68H446.82V91.274ZM448.602 104.072H449.916V90.68H449.16V95.918L449.232 101.264L449.574 101.138L442.392 90.68H438.396V91.274L439.908 91.4L440.502 92.318L440.556 92.372L448.602 104.072ZM459.849 104.342C461.523 104.342 462.765 103.982 464.169 103.172V102.272C464.169 100.526 464.205 99.014 464.241 97.52H461.685C461.721 99.122 461.757 100.616 461.757 102.2V103.676L462.621 103.136C461.811 103.496 461.037 103.676 460.137 103.676C457.509 103.676 455.583 101.282 455.583 97.34C455.583 93.146 457.599 91.004 460.281 91.004C461.397 91.004 462.171 91.31 463.179 92.12V91.382L461.883 90.896L462.801 94.496H463.827L463.845 91.328C462.729 90.698 461.523 90.338 459.957 90.338C455.763 90.338 452.883 93.056 452.883 97.304C452.883 101.66 455.691 104.342 459.849 104.342ZM459.723 98.096L462.225 98.366H463.233L465.393 98.096V97.52H459.723V98.096ZM194.586 130.342C196.206 130.342 197.466 129.982 198.6 129.298L198.564 126.184H197.592L196.656 129.73L197.916 129.316V128.668C196.926 129.388 196.062 129.676 195.036 129.676C192.336 129.676 190.32 127.66 190.32 123.358C190.32 119.074 192.336 117.004 195.018 117.004C196.08 117.004 196.872 117.292 197.808 117.94V117.346L196.512 116.914L197.466 120.496H198.438L198.474 117.364C197.304 116.698 196.206 116.338 194.604 116.338C190.716 116.338 187.62 118.804 187.62 123.448C187.62 128.02 190.626 130.342 194.586 130.342ZM200.097 130H205.029V129.478L203.139 129.28H201.987L200.097 129.478V130ZM201.375 130H203.913C203.859 129.1 203.841 127.03 203.841 125.788V122.278L203.805 122.044V118.3L203.859 115.438L203.607 115.276L200.007 115.96V116.446L201.429 116.554V125.788C201.429 127.03 201.411 129.1 201.375 130ZM206.325 130H211.257V129.478L209.313 129.28H208.179L206.325 129.478V130ZM207.549 130H210.105C210.051 129.1 210.033 127.084 210.033 125.788V123.556C210.033 121.09 208.935 120.082 207.243 120.082C205.821 120.082 204.723 120.748 203.481 122.332H202.743L203.265 123.088C204.363 121.828 205.389 121.288 206.181 121.288C207.063 121.288 207.621 121.828 207.621 123.358V125.788C207.621 127.084 207.603 129.1 207.549 130ZM216.308 130.306C217.82 130.306 219.026 129.406 219.908 128.146H220.772L220.16 127.246C219.458 128.236 218.522 128.938 217.496 128.938C216.524 128.938 215.93 128.416 215.93 126.814V123.016L216.038 120.388L215.822 120.19L212.222 120.64V121.126L214.076 121.45L213.554 121.054L213.5 126.634C213.464 129.334 214.544 130.306 216.308 130.306ZM219.764 130.234L223.328 130.018V129.496L222.104 129.37V123.016L222.176 120.388L221.978 120.19L218.432 120.712V121.126L219.728 121.342L219.674 128.002V128.038L219.764 130.234ZM216.56 118.426L216.938 118.714C217.55 118.192 218.198 117.688 219.278 116.95C220.034 116.446 220.34 115.978 220.34 115.51C220.34 114.952 219.908 114.628 219.494 114.628C218.972 114.628 218.612 114.952 218.18 115.708C217.46 116.932 217.01 117.67 216.56 118.426ZM229.443 130.306C231.369 130.306 232.539 129.568 233.385 128.056L233.061 127.822C232.395 128.686 231.513 129.154 230.469 129.154C228.471 129.154 227.157 127.642 227.157 125.014C227.157 122.278 228.417 120.676 230.091 120.676C230.721 120.676 231.297 120.856 231.981 121.252L230.757 120.46L231.081 122.152C231.153 123.232 231.675 123.61 232.341 123.61C232.881 123.61 233.223 123.34 233.385 122.764C233.115 121.216 231.657 120.082 229.821 120.082C226.995 120.082 224.601 121.918 224.601 125.338C224.601 128.524 226.725 130.306 229.443 130.306ZM239.261 130L242.627 130.252L243.005 128.614V121.828L242.969 121.648V118.3L243.023 115.438L242.771 115.276L239.171 115.96V116.446L240.593 116.554V125.788C240.593 126.796 240.575 128.326 240.557 129.37L239.261 129.478V130ZM245.813 130.306C248.243 130.306 249.953 128.074 249.953 125.14C249.953 121.9 248.261 120.082 246.029 120.082C244.697 120.082 243.455 120.676 242.447 122.044H242.105L242.339 122.566C243.419 121.36 244.121 121.18 244.877 121.18C246.317 121.18 247.361 122.314 247.361 125.086C247.361 128.29 246.173 129.172 244.823 129.172C244.067 129.172 243.419 128.884 242.717 128.092L242.393 128.398H242.591C243.455 129.694 244.589 130.306 245.813 130.306ZM251.357 127.894C251.357 129.406 252.437 130.306 253.931 130.306C255.389 130.306 256.109 129.676 257.153 128.524L257.783 127.804L257.675 127.498L257.045 128.092C256.199 128.884 255.695 129.19 255.083 129.19C254.165 129.19 253.607 128.668 253.607 127.57C253.607 126.382 254.237 125.554 255.605 125.014C256.163 124.798 257.243 124.51 258.215 124.276V123.808C257.243 124.042 255.911 124.366 254.975 124.636C252.257 125.464 251.357 126.346 251.357 127.894ZM258.971 130.288C259.979 130.288 260.591 129.928 261.023 129.064L260.735 128.812C260.393 129.28 260.195 129.406 259.925 129.406C259.529 129.406 259.295 129.136 259.295 128.308V123.592C259.295 121.108 258.287 120.082 255.875 120.082C253.355 120.082 251.861 121.09 251.663 122.71C251.771 123.232 252.167 123.538 252.743 123.538C253.337 123.538 253.841 123.124 253.913 122.098L254.111 120.712L252.977 121.18C253.841 120.802 254.453 120.676 255.065 120.676C256.451 120.676 256.955 121.234 256.955 123.142V128.326C257.099 129.532 257.747 130.288 258.971 130.288ZM255.713 134.158C256.469 134.158 257.099 133.618 257.099 132.844C257.099 132.106 256.469 131.566 255.713 131.566C254.975 131.566 254.345 132.106 254.345 132.844C254.345 133.618 254.975 134.158 255.713 134.158ZM261.742 130H266.692V129.478L264.784 129.28H263.65L261.742 129.478V130ZM263.02 130H265.558C265.522 129.1 265.504 127.03 265.504 125.788V122.296L265.378 120.262L265.144 120.1L261.616 121.09V121.54L263.02 121.666C263.056 122.53 263.074 123.232 263.074 124.42V125.788C263.074 127.03 263.056 129.1 263.02 130ZM267.97 130H272.902V129.478L270.958 129.28H269.842L267.97 129.478V130ZM269.212 130H271.75C271.714 129.1 271.678 127.084 271.678 125.788V123.52C271.678 121.144 270.58 120.082 268.924 120.082C267.61 120.082 266.458 120.64 265.108 122.35H264.838L264.928 123.106C266.026 121.828 267.142 121.288 267.88 121.288C268.78 121.288 269.266 121.828 269.266 123.358V125.788C269.266 127.084 269.248 129.1 269.212 130ZM279.861 118.048V118.678L282.165 118.408V125.788C282.165 127.156 282.147 128.596 282.111 130H284.685C284.631 128.596 284.613 127.156 284.613 125.788V120.082L284.685 117.166L284.415 116.968L279.861 118.048ZM284.523 129.154H282.291L279.465 129.478V130H287.169V129.478L284.523 129.154ZM293.647 130H298.597V129.478L296.689 129.28H295.555L293.647 129.478V130ZM294.925 130H297.463C297.427 129.1 297.409 127.03 297.409 125.788V122.296L297.283 120.262L297.049 120.1L293.521 121.09V121.54L294.925 121.666C294.961 122.53 294.979 123.232 294.979 124.42V125.788C294.979 127.03 294.961 129.1 294.925 130ZM299.875 130H304.807V129.478L302.863 129.28H301.747L299.875 129.478V130ZM301.117 130H303.655C303.619 129.1 303.583 127.084 303.583 125.788V123.52C303.583 121.144 302.485 120.082 300.829 120.082C299.515 120.082 298.363 120.64 297.013 122.35H296.743L296.833 123.106C297.931 121.828 299.047 121.288 299.785 121.288C300.685 121.288 301.171 121.828 301.171 123.358V125.788C301.171 127.084 301.153 129.1 301.117 130ZM309.911 134.68C313.511 134.68 315.545 132.862 315.545 131.008C315.545 129.442 314.483 128.38 311.801 128.38H309.155C308.201 128.38 307.805 128.02 307.805 127.444C307.805 126.886 308.021 126.526 308.489 125.932L308.147 125.752V125.914C306.851 126.796 306.419 127.588 306.419 128.416C306.419 129.28 306.923 129.874 307.895 130.162V130.216C308.399 130.378 308.867 130.396 309.785 130.396H311.855C313.169 130.396 313.601 131.08 313.601 131.728C313.601 133.06 312.377 133.924 309.929 133.924C308.291 133.924 307.337 133.24 307.337 131.926C307.337 131.116 307.679 130.666 308.363 130L308.309 129.874C306.653 130.45 305.861 131.296 305.861 132.304C305.861 133.618 306.797 134.68 309.911 134.68ZM310.235 126.598C312.827 126.598 314.177 125.23 314.177 123.358C314.177 122.494 313.907 121.738 313.385 121.198L313.313 121.126C312.683 120.478 311.657 120.082 310.253 120.082C307.625 120.082 306.275 121.432 306.275 123.358C306.275 125.23 307.625 126.598 310.235 126.598ZM310.235 126.04C309.101 126.04 308.471 124.996 308.471 123.358C308.471 121.666 309.137 120.64 310.253 120.64C311.333 120.64 312.017 121.648 312.017 123.358C312.017 124.996 311.351 126.04 310.235 126.04ZM312.719 121.324L315.707 121.558V120.298L315.383 120.1L312.827 121.036H312.719V121.324ZM319.128 130.306C320.586 130.306 321.306 129.676 322.35 128.524H322.98L322.71 127.57C321.486 128.884 320.856 129.19 320.28 129.19C319.398 129.19 318.804 128.65 318.804 127.57C318.804 126.364 319.47 125.554 320.766 125.032C321.396 124.798 322.44 124.528 323.412 124.276V123.808C322.44 124.042 321.126 124.366 320.19 124.654C317.436 125.41 316.554 126.328 316.554 127.894C316.554 129.406 317.634 130.306 319.128 130.306ZM324.168 130.288C325.176 130.288 325.806 129.91 326.238 129.046L325.932 128.794C325.608 129.262 325.41 129.406 325.122 129.406C324.726 129.406 324.528 129.136 324.528 128.308V123.592C324.528 121.108 323.484 120.082 321.09 120.082C318.552 120.082 317.058 121.09 316.842 122.692C316.968 123.232 317.364 123.52 317.94 123.52C318.534 123.52 319.056 123.142 319.11 122.098L319.308 120.712L318.174 121.162C319.038 120.82 319.65 120.676 320.28 120.676C321.666 120.676 322.152 121.234 322.152 123.142V128.326C322.296 129.532 322.926 130.288 324.168 130.288ZM321.936 118.426C321.504 117.688 321.036 116.932 320.37 115.69C319.938 114.934 319.542 114.628 319.02 114.628C318.606 114.628 318.156 114.952 318.156 115.51C318.156 115.978 318.552 116.428 319.29 116.95C320.334 117.67 320.946 118.192 321.576 118.714L321.936 118.426ZM327.775 134.878C329.269 134.878 330.475 133.834 331.627 130.774L335.497 120.37H334.759L333.301 124.798L331.717 129.118L331.573 129.55L331.015 130.846C330.277 132.682 329.539 133.762 328.405 134.248L328.747 134.554L329.377 134.14L328.837 133.492C328.405 132.988 327.919 132.61 327.289 132.61C326.641 132.61 326.029 132.934 325.903 133.636C325.957 134.41 326.839 134.878 327.775 134.878ZM331.141 131.314L332.239 128.452L332.131 128.254L329.251 120.37H326.623L331.141 131.314ZM325.867 120.892L327.685 121.09H329.233L331.015 120.892V120.37H325.867V120.892ZM332.761 120.892L334.651 121.072H334.975L336.451 120.892V120.37H332.761V120.892ZM341.581 130H346.819V129.478L344.731 129.28H343.597L341.581 129.478V130ZM342.949 130H345.487C345.433 128.758 345.415 127.138 345.415 125.788V118.3L345.487 115.438L345.217 115.276L341.581 115.96V116.446L343.003 116.554V125.788C343.003 127.138 342.985 128.758 342.949 130ZM350.593 130.306C352.051 130.306 352.771 129.676 353.815 128.524H354.445L354.175 127.57C352.951 128.884 352.321 129.19 351.745 129.19C350.863 129.19 350.269 128.65 350.269 127.57C350.269 126.364 350.935 125.554 352.231 125.032C352.861 124.798 353.905 124.528 354.877 124.276V123.808C353.905 124.042 352.591 124.366 351.655 124.654C348.901 125.41 348.019 126.328 348.019 127.894C348.019 129.406 349.099 130.306 350.593 130.306ZM355.633 130.288C356.641 130.288 357.271 129.91 357.703 129.046L357.397 128.794C357.073 129.262 356.875 129.406 356.587 129.406C356.191 129.406 355.993 129.136 355.993 128.308V123.592C355.993 121.108 354.949 120.082 352.555 120.082C350.017 120.082 348.523 121.09 348.307 122.692C348.433 123.232 348.829 123.52 349.405 123.52C349.999 123.52 350.521 123.142 350.575 122.098L350.773 120.712L349.639 121.162C350.503 120.82 351.115 120.676 351.745 120.676C353.131 120.676 353.617 121.234 353.617 123.142V128.326C353.761 129.532 354.391 130.288 355.633 130.288ZM353.401 118.426C352.969 117.688 352.501 116.932 351.835 115.69C351.403 114.934 351.007 114.628 350.485 114.628C350.071 114.628 349.621 114.952 349.621 115.51C349.621 115.978 350.017 116.428 350.755 116.95C351.799 117.67 352.411 118.192 353.041 118.714L353.401 118.426ZM358.404 130H363.354V129.478L361.446 129.28H360.312L358.404 129.478V130ZM359.682 130H362.22C362.184 129.1 362.166 127.03 362.166 125.788V122.242L362.04 120.262L361.806 120.1L358.278 121.09V121.522L359.682 121.648C359.736 122.53 359.736 123.214 359.736 124.402V125.788C359.736 127.03 359.718 129.1 359.682 130ZM364.506 130H369.366V129.478L367.494 129.28H366.342L364.506 129.478V130ZM365.73 130H368.232C368.196 129.1 368.16 127.084 368.16 125.788V123.52C368.16 121.144 367.206 120.082 365.46 120.082C364.002 120.082 362.868 120.892 361.806 122.35H361.518L361.608 123.178C362.562 122.008 363.552 121.306 364.452 121.306C365.352 121.306 365.802 121.918 365.802 123.484V125.788C365.802 127.084 365.784 129.1 365.73 130ZM370.536 130H375.396V129.478L373.488 129.28H372.3L370.536 129.478V130ZM371.742 130H374.226C374.19 129.1 374.172 127.084 374.172 125.788V123.592C374.172 121.144 373.254 120.082 371.364 120.082C370.032 120.082 368.88 120.694 367.8 122.206H367.458L367.566 123.124C368.592 121.882 369.528 121.306 370.41 121.306C371.328 121.306 371.796 121.81 371.796 123.484V125.788C371.796 127.084 371.778 129.1 371.742 130ZM384.969 130.072H386.031L389.703 120.37H388.893L386.319 127.948L386.211 128.2H386.589L383.673 120.37H381.009L384.969 130.072ZM380.235 120.892L381.999 121.108H383.511L385.401 120.892V120.37H380.235V120.892ZM387.183 120.892L388.893 121.108H389.253L390.711 120.892V120.37H387.183V120.892ZM391.523 130H396.491V129.478L394.547 129.28H393.431L391.523 129.478V130ZM392.783 130H395.339C395.285 129.1 395.267 127.03 395.267 125.788V123.034L395.321 120.262L395.105 120.1L391.361 121.054V121.504L392.783 121.612C392.819 122.476 392.837 123.268 392.837 124.456V125.788C392.837 127.03 392.819 129.1 392.783 130ZM393.953 118.21C394.727 118.21 395.339 117.67 395.339 116.896C395.339 116.14 394.727 115.582 393.953 115.582C393.197 115.582 392.585 116.14 392.585 116.896C392.585 117.67 393.197 118.21 393.953 118.21ZM402.713 120.082C400.229 120.082 397.799 121.9 397.799 125.158C397.799 128.488 399.941 130.306 402.731 130.306C404.477 130.306 405.863 129.46 406.601 128.038L406.277 127.804C405.647 128.632 404.837 129.154 403.577 129.154C401.795 129.154 400.355 127.894 400.355 124.888C400.355 121.99 401.345 120.676 402.551 120.676C403.685 120.676 404.441 121.63 404.441 123.16C404.441 124.15 404.243 124.528 403.469 124.528L398.861 124.492V125.14H406.601C406.691 124.816 406.709 124.492 406.709 124.06C406.709 121.828 405.287 120.082 402.713 120.082ZM405.287 118.894L405.647 118.57L403.127 115.078H402.137L399.635 118.57L399.995 118.894L403.343 116.23H401.939L405.287 118.894ZM402.479 134.158C403.235 134.158 403.847 133.618 403.847 132.844C403.847 132.106 403.235 131.566 402.479 131.566C401.723 131.566 401.111 132.106 401.111 132.844C401.111 133.618 401.723 134.158 402.479 134.158ZM412.941 130.306C414.867 130.306 416.037 129.568 416.883 128.056L416.559 127.822C415.893 128.686 415.011 129.154 413.967 129.154C411.969 129.154 410.655 127.642 410.655 125.014C410.655 122.278 411.915 120.676 413.589 120.676C414.219 120.676 414.795 120.856 415.479 121.252L414.255 120.46L414.579 122.152C414.651 123.232 415.173 123.61 415.839 123.61C416.379 123.61 416.721 123.34 416.883 122.764C416.613 121.216 415.155 120.082 413.319 120.082C410.493 120.082 408.099 121.918 408.099 125.338C408.099 128.524 410.223 130.306 412.941 130.306ZM422.759 130H427.691V129.478L425.801 129.28H424.649L422.759 129.478V130ZM424.037 130H426.575C426.521 129.1 426.503 127.03 426.503 125.788V122.278L426.467 122.044V118.3L426.521 115.438L426.269 115.276L422.669 115.96V116.446L424.091 116.554V125.788C424.091 127.03 424.073 129.1 424.037 130ZM428.987 130H433.919V129.478L431.975 129.28H430.841L428.987 129.478V130ZM430.211 130H432.767C432.713 129.1 432.695 127.084 432.695 125.788V123.556C432.695 121.09 431.597 120.082 429.905 120.082C428.483 120.082 427.385 120.748 426.143 122.332H425.405L425.927 123.088C427.025 121.828 428.051 121.288 428.843 121.288C429.725 121.288 430.283 121.828 430.283 123.358V125.788C430.283 127.084 430.265 129.1 430.211 130ZM435.135 130H440.103V129.478L438.159 129.28H437.043L435.135 129.478V130ZM436.395 130H438.951C438.897 129.1 438.879 127.03 438.879 125.788V123.034L438.933 120.262L438.717 120.1L434.973 121.054V121.504L436.395 121.612C436.431 122.476 436.449 123.268 436.449 124.456V125.788C436.449 127.03 436.431 129.1 436.395 130ZM437.565 118.21C438.339 118.21 438.951 117.67 438.951 116.896C438.951 116.14 438.339 115.582 437.565 115.582C436.809 115.582 436.197 116.14 436.197 116.896C436.197 117.67 436.809 118.21 437.565 118.21ZM446.324 120.082C443.84 120.082 441.41 121.9 441.41 125.158C441.41 128.488 443.552 130.306 446.342 130.306C448.088 130.306 449.474 129.46 450.212 128.038L449.888 127.804C449.258 128.632 448.448 129.154 447.188 129.154C445.406 129.154 443.966 127.894 443.966 124.888C443.966 121.99 444.956 120.676 446.162 120.676C447.296 120.676 448.052 121.63 448.052 123.16C448.052 124.15 447.854 124.528 447.08 124.528L442.472 124.492V125.14H450.212C450.302 124.816 450.32 124.492 450.32 124.06C450.32 121.828 448.898 120.082 446.324 120.082ZM448.898 118.894L449.258 118.57L446.738 115.078H445.748L443.246 118.57L443.606 118.894L446.954 116.23H445.55L448.898 118.894ZM446.09 134.158C446.846 134.158 447.458 133.618 447.458 132.844C447.458 132.106 446.846 131.566 446.09 131.566C445.334 131.566 444.722 132.106 444.722 132.844C444.722 133.618 445.334 134.158 446.09 134.158ZM455.599 130.306C457.111 130.306 458.317 129.406 459.199 128.146H460.063L459.451 127.246C458.749 128.236 457.813 128.938 456.787 128.938C455.815 128.938 455.221 128.416 455.221 126.814V123.016L455.329 120.388L455.113 120.19L451.513 120.64V121.126L453.367 121.45L452.845 121.054L452.791 126.634C452.755 129.334 453.835 130.306 455.599 130.306ZM459.055 130.234L462.619 130.018V129.496L461.395 129.37V123.016L461.467 120.388L461.269 120.19L457.723 120.712V121.126L459.019 121.342L458.965 128.002V128.038L459.055 130.234ZM473.81 134.68H479.03V134.158L477.158 133.978H475.736L473.81 134.158V134.68ZM472.424 130.306C473.72 130.306 474.854 129.73 475.736 128.488H475.862L475.628 128.2C474.944 128.902 474.368 129.172 473.594 129.172C472.082 129.172 471.002 128.11 471.002 125.266C471.002 122.314 472.118 121.18 473.594 121.18C474.332 121.18 474.962 121.45 475.646 122.152L475.934 121.864L475.844 121.81C475.088 120.622 474.008 120.082 472.856 120.082C470.354 120.082 468.41 122.08 468.41 125.302C468.41 128.434 470.12 130.306 472.424 130.306ZM475.304 134.68H477.806C477.752 133.276 477.734 131.872 477.734 130.45V123.016L477.806 120.28L477.518 120.136L475.304 121.63V128.56L475.376 128.776V130.45C475.376 131.872 475.358 133.276 475.304 134.68ZM483.777 130.306C485.289 130.306 486.495 129.406 487.377 128.146H488.241L487.629 127.246C486.927 128.236 485.991 128.938 484.965 128.938C483.993 128.938 483.399 128.416 483.399 126.814V123.016L483.507 120.388L483.291 120.19L479.691 120.64V121.126L481.545 121.45L481.023 121.054L480.969 126.634C480.933 129.334 482.013 130.306 483.777 130.306ZM487.233 130.234L490.797 130.018V129.496L489.573 129.37V123.016L489.645 120.388L489.447 120.19L485.901 120.712V121.126L487.197 121.342L487.143 128.002V128.038L487.233 130.234ZM492.16 127.894C492.16 129.406 493.24 130.306 494.734 130.306C496.192 130.306 496.912 129.676 497.956 128.524L498.586 127.804L498.478 127.498L497.848 128.092C497.002 128.884 496.498 129.19 495.886 129.19C494.968 129.19 494.41 128.668 494.41 127.57C494.41 126.382 495.04 125.554 496.408 125.014C496.966 124.798 498.046 124.51 499.018 124.276V123.808C498.046 124.042 496.714 124.366 495.778 124.636C493.06 125.464 492.16 126.346 492.16 127.894ZM499.774 130.288C500.782 130.288 501.394 129.928 501.826 129.064L501.538 128.812C501.196 129.28 500.998 129.406 500.728 129.406C500.332 129.406 500.098 129.136 500.098 128.308V123.592C500.098 121.108 499.09 120.082 496.678 120.082C494.158 120.082 492.664 121.09 492.466 122.71C492.574 123.232 492.97 123.538 493.546 123.538C494.14 123.538 494.644 123.124 494.716 122.098L494.914 120.712L493.78 121.18C494.644 120.802 495.256 120.676 495.868 120.676C497.254 120.676 497.758 121.234 497.758 123.142V128.326C497.902 129.532 498.55 130.288 499.774 130.288ZM496.426 118.93C497.848 118.768 498.55 118.012 498.55 116.986C498.55 115.654 497.704 114.88 495.814 114.7L495.652 116.248C497.092 116.464 497.56 116.698 497.56 117.346C497.56 117.886 497.308 118.21 496.318 118.48L496.426 118.93ZM505.013 130.27C505.877 130.27 506.525 129.622 506.525 128.794C506.525 127.984 505.877 127.336 505.013 127.336C504.167 127.336 503.519 127.984 503.519 128.794C503.519 129.622 504.167 130.27 505.013 130.27ZM505.013 116.392C504.113 116.392 503.555 116.914 503.555 117.886C503.555 118.786 503.789 120.136 504.365 122.764L504.725 125.572H505.283L505.661 122.764C506.237 120.136 506.471 118.786 506.471 117.886C506.471 116.914 505.895 116.392 505.013 116.392Z"
              fill="#66D54A"/>
          <g clip-path="url(#clip0_253_9)">
            <path
                d="M540 132C553.807 132 565 123.941 565 114C565 104.059 553.807 96 540 96C526.193 96 515 104.059 515 114C515 123.941 526.193 132 540 132Z"
                fill="#FFDD67"/>
            <path
                d="M540 124.814C536.993 124.815 534.06 124.14 531.611 122.883C529.161 121.627 527.317 119.852 526.334 117.806C526.251 117.651 526.212 117.486 526.219 117.32C526.227 117.154 526.28 116.992 526.377 116.841C526.474 116.691 526.612 116.556 526.782 116.444C526.953 116.333 527.153 116.248 527.371 116.193C527.588 116.139 527.819 116.117 528.049 116.128C528.279 116.139 528.503 116.184 528.708 116.259C528.914 116.334 529.096 116.438 529.244 116.565C529.393 116.692 529.504 116.839 529.571 116.997C530.317 118.562 531.723 119.92 533.593 120.881C535.463 121.842 537.703 122.359 540 122.359C542.297 122.359 544.537 121.842 546.407 120.881C548.277 119.92 549.683 118.562 550.429 116.997C550.496 116.839 550.607 116.692 550.756 116.565C550.904 116.438 551.086 116.334 551.292 116.259C551.497 116.184 551.721 116.139 551.951 116.128C552.181 116.117 552.412 116.139 552.629 116.193C552.847 116.248 553.047 116.333 553.218 116.444C553.388 116.556 553.526 116.691 553.623 116.841C553.72 116.992 553.773 117.154 553.781 117.32C553.788 117.486 553.749 117.651 553.666 117.806C552.683 119.852 550.839 121.627 548.389 122.883C545.94 124.14 543.007 124.815 540 124.814V124.814Z"
                fill="#B26D3C"/>
            <path
                d="M548.286 108.09C545.143 108.09 542.603 111.511 542.603 110.204C542.603 108.898 545.146 105.601 548.286 105.601C551.426 105.601 553.971 108.892 553.971 110.204C553.971 111.517 551.426 108.09 548.286 108.09V108.09Z"
                fill="#B26D3C"/>
            <path
                d="M531.714 108.003C528.571 108.003 526.029 111.427 526.029 110.12C526.029 108.814 528.574 105.516 531.714 105.516C534.854 105.516 537.397 108.808 537.397 110.12C537.397 111.433 534.854 108.003 531.714 108.003Z"
                fill="#B26D3C"/>
          </g>
          <path
              d="M207.744 94.1158L198.14 99.359L193.565 96.651C192.961 96.3053 192.006 96.3053 191.453 96.6222C190.849 96.9679 190.849 97.5152 191.403 97.8321L197.034 101.145C197.336 101.318 197.738 101.404 198.09 101.404C198.442 101.404 198.844 101.318 199.146 101.174L209.856 95.3546C210.459 95.0377 210.509 94.4903 209.906 94.1446C209.303 93.7989 208.347 93.7989 207.744 94.1158Z"
              fill="url(#paint0_linear_253_9)"/>
          <path
              d="M200.604 87C190.347 87 182 91.7823 182 97.6593C182 103.536 190.347 108.319 200.604 108.319C210.861 108.319 219.208 103.536 219.208 97.6593C219.208 91.7823 210.861 87 200.604 87ZM200.604 106.59C192.006 106.59 185.017 102.586 185.017 97.6593C185.017 92.733 192.006 88.7285 200.604 88.7285C209.202 88.7285 216.191 92.733 216.191 97.6593C216.191 102.586 209.202 106.59 200.604 106.59Z"
              fill="url(#paint1_linear_253_9)"/>
          <ellipse cx="37.5" cy="8.5" fill="#46C4BC" rx="14.5" ry="8.5"/>
          <ellipse cx="14" cy="35" fill="#D11F3F" rx="12" ry="15"/>
          <ellipse cx="54.5" cy="89.5" fill="#B26D3C" rx="9.5" ry="12.5"/>
          <ellipse cx="55.5" cy="51" fill="#D9D9D9" rx="7.5" ry="4"/>
          <ellipse cx="36" cy="64.5" fill="#2467E8" rx="6" ry="9.5"/>
          <path
              d="M83.8273 53.531C83.8273 64.8528 70.8436 74.031 54.8273 74.031C38.811 74.031 42.3274 44.3541 42.3274 33.0323C42.3274 21.7104 38.811 33.031 54.8273 33.031C70.8436 33.031 83.8273 42.2092 83.8273 53.531Z"
              fill="#FF5A5A"/>
          <ellipse cx="112" cy="24.5" fill="#8588D1" rx="6" ry="4.5"/>
          <circle cx="85.5" cy="76.5" fill="#2D45C5" r="3.5"/>
          <ellipse cx="77.5" cy="92.5" fill="#A5D798" rx="0.5" ry="1.5"/>
          <ellipse cx="109.5" cy="60" fill="#FE1B1B" rx="2.5" ry="5"/>
          <ellipse cx="89.5" cy="96.5" fill="#9D0909" rx="5.5" ry="10.5"/>
          <ellipse cx="9" cy="67" fill="#FFDD67" rx="9" ry="13"/>
          <circle cx="78" cy="21" fill="white" r="4"/>
          <circle cx="92.5" cy="39.5" fill="#A75252" r="2.5"/>
          <ellipse cx="93.5" cy="59" fill="#683535" rx="1.5" ry="1"/>
          <ellipse cx="70" cy="102.5" fill="#440C0C" rx="1" ry="4.5"/>
          <ellipse cx="32.5" cy="28" fill="#382828" rx="3.5" ry="1"/>
          <defs>
            <filter id="filter0_d_253_9" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="133" width="444" x="146.5"
                    y="23.5">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
                             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_253_9"/>
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_253_9" mode="normal" result="shape"/>
            </filter>
            <filter id="filter1_d_253_9" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="26" width="30" x="347.5"
                    y="38.5">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
                             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_253_9"/>
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_253_9" mode="normal" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_253_9" gradientUnits="userSpaceOnUse" x1="200.664" x2="200.664" y1="86.7839"
                            y2="109.648">
              <stop stop-color="#70D755"/>
              <stop offset="1" stop-color="#00ACEA"/>
            </linearGradient>
            <linearGradient id="paint1_linear_253_9" gradientUnits="userSpaceOnUse" x1="200.604" x2="200.604" y1="86.7839"
                            y2="109.648">
              <stop stop-color="#66D44A"/>
              <stop offset="1" stop-color="#00ACEA"/>
            </linearGradient>
            <clipPath id="clip0_253_9">
              <rect fill="white" height="36" transform="translate(515 96)" width="50"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </b-modal>

    <b-modal id="modal-new-detail" hide-footer hide-header no-close-on-backdrop no-close-on-esc size="xl" title="">
      <b-row>
        <b-col class="new-detail" cols="12" md="12" sm="12" xs="12">
          <div v-if="Object.keys(currentItem).length > 0" class="text-left">
            <b-row class="text-right">
              <b-col md="9" sm="8" xs="12"></b-col>
              <b-col class="header-status" md="3" sm="4" xs="4">
                <b-form-group>
                  <label>Trạng thái: </label>
                  <label :class="currentItem.status == 1 ? 'status-1' : 'status-2'" class="ml-50">
                    {{ currentItem.statusName }}</label>
                </b-form-group>
                <div class="hr-bottom"></div>
              </b-col>
            </b-row>
            <b-row class="detail-tile">
              {{ currentItem.catName }} &#62; {{ currentItem.topicName }} &#62; {{ currentItem.name }}
            </b-row>
            <b-row class="use-new">
              <b-col cols="12">
                <b-form-group>
                  <!-- eslint-disable vue/no-v-html -->
                  <div class="question-content" v-html="currentItem.contents"/>
                  <!-- eslint-enable -->
                </b-form-group>
              </b-col>
              <b-col v-if="currentItem.file_path && currentItem.file_path.length > 0" cols="12">
                <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                               @click="downloadFile(currentItem.file_path)">
                  <div class="sample-file__download">
                    <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                  </div>
                  {{ currentItem.file_path.split('/')[1] }}
                </b-input-group>
              </b-col>
            </b-row>
            <b-row class="text-right">
              <b-col md="8" sm="6" xs="12">
                <b-form-group>
                  <label>Ngày tạo: </label>
                  <label class="ml-50">
                    <b>{{this.dateFormat(currentItem.created_date) }}</b></label>
                </b-form-group>

              </b-col>
              <b-col md="4" sm="6" xs="12">
                <b-form-group>
                  <label>Người soạn: </label>
                  <label class="ml-50">
                    <b>{{ currentItem.created_at }}</b></label>
                </b-form-group>
                <div class="mt-1">&nbsp;</div>
              </b-col>
            </b-row>
            <b-row class="text-right">
              <b-col md="8" sm="6" xs="12">
                <b-form-group>
                  <label>Ngày sửa: </label>
                  <label class="ml-50">
                    <b>{{this.dateFormat(currentItem.updated_date) }}</b></label>
                </b-form-group>
              </b-col>
              <b-col v-if="currentItem.updated_at" md="4" sm="6" xs="12">
                <b-form-group>
                  <label>Người sửa: </label>
                  <label class="ml-50">
                    <b>{{ currentItem.updated_at }}</b></label>
                </b-form-group>
                <div class="mt-1">&nbsp;</div>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <div class="mt-1">&nbsp;</div>
            </b-row>
            <b-row class="text-center">
              <b-col cols="12">
                <b-button class="btn-sm btn-close" variant="primary"
                          @click="closeModal('modal-new-detail')">ĐÓNG
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-notices-detail" hide-footer hide-header no-close-on-backdrop no-close-on-esc size="xl" title="">
      <b-row>
        <b-col class="new-detail" cols="12" md="12" sm="12" xs="12">
          <div v-if="Object.keys(currentItem).length > 0" class="text-left">
            <b-row class="text-right">
              <b-col md="9" sm="8" xs="12"></b-col>
              <b-col class="header-status" md="3" sm="4" xs="4">
                <b-form-group>
                  <label>Trạng thái: </label>
                  <label :class="currentItem.status == 1 ? 'status-1' : 'status-2'" class="ml-50">
                    {{ currentItem.status_name }}</label>
                </b-form-group>
                <div class="hr-bottom"></div>
              </b-col>
            </b-row>
            <b-row class="detail-tile">
              {{ currentItem.type_notice_name }} &#62; {{ currentItem.name }}
            </b-row>
            <b-row class="use-new">
              <b-col cols="12">
                <b-form-group>
                  <!-- eslint-disable vue/no-v-html -->
                  <div class="question-content" v-html="currentItem.contents"/>
                  <!-- eslint-enable -->
                </b-form-group>
              </b-col>
              <b-col v-if="currentItem.file_path && currentItem.file_path.length > 0" cols="12">
                <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                               @click="downloadFile(currentItem.file_path)">
                  <div class="sample-file__download">
                    <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                  </div>
                  {{ currentItem.file_path.split('/')[1] }}
                </b-input-group>
              </b-col>
            </b-row>
            <b-row class="text-right">
              <b-col md="8" sm="6" xs="12">
                <b-form-group>
                  <label>Ngày tạo: </label>
                  <label class="ml-50">
                    <b>{{this.dateFormat(currentItem.created_date) }}</b></label>
                </b-form-group>

              </b-col>
              <b-col md="4" sm="6" xs="12">
                <b-form-group>
                  <label>Người soạn: </label>
                  <label class="ml-50">
                    <b>{{ currentItem.created_at }}</b></label>
                </b-form-group>
                <div class="mt-1">&nbsp;</div>
              </b-col>
            </b-row>
            <b-row class="text-right">
              <b-col md="8" sm="6" xs="12">
                <b-form-group>
                  <label>Ngày sửa: </label>
                  <label class="ml-50">
                    <b>{{this.dateFormat(currentItem.updated_date) }}</b></label>
                </b-form-group>

              </b-col>
              <b-col v-if="currentItem.updated_at" md="4" sm="6" xs="12">
                <b-form-group>
                  <label>Người sửa: </label>
                  <label class="ml-50">
                    <b>{{ currentItem.updated_at }}</b></label>
                </b-form-group>
                <div class="mt-1">&nbsp;</div>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <div class="mt-1">&nbsp;</div>
            </b-row>
            <b-row class="text-center">
              <b-col cols="12">
                <b-button class="btn-sm btn-close" variant="primary"
                          @click="closeModal('modal-notices-detail')">ĐÓNG
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal id="modal-hot-notices" hide-footer hide-header no-close-on-backdrop no-close-on-esc size="xl" title="">
      <b-row class="hot-new-content-popup">
        <b-col md="12" sm="12" xs="12">
          <div class="content-cat">
            <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [50, 100], dropdownAllowAll: false }" :rows="listNotices"
                            :totalRows="totalRecordHot" max-height="420px" mode="remote"
                            styleClass="vgt-table striped"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                  <span v-title="props.row.contents"
                        :style="[props.row.isRead ? { opacity: 0.5 } : { opacity: 1 }]"
                        style="font-weight: bold; color: blue; cursor: pointer; line-height: 30px;"
                        @click="detailNoticeShow(props.row)">{{ props.row.name }}</span>
                </span>
                <span v-else-if="props.column.field == 'topic_name'">
                  {{ props.row.originalIndex + 1 }}. {{ props.row.topic_name }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
          <div class="mt-50" style="height: 40px">&nbsp;</div>
          <div class="clearfix"></div>
        </b-col>
        <b-col class="text-center  mt-50" cols="12">
          <b-button class="btn-sm mr-50 btn-confirm" variant="primary" @click="confirmNotices()">
            <i class="fa confirm-custom">
              <svg fill="none" height="18" viewBox="0 0 27 18" width="27"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M18.6811 6.00804L11.7122 10.4351L8.39189 8.14858C7.95405 7.85669 7.26081 7.85669 6.85945 8.12425C6.42162 8.41615 6.42162 8.87831 6.82297 9.14587L10.9095 11.9432C11.1284 12.0891 11.4203 12.1621 11.6757 12.1621C11.9311 12.1621 12.223 12.0891 12.4419 11.9675L20.2135 7.05398C20.6513 6.78642 20.6878 6.32425 20.25 6.03236C19.8122 5.74047 19.1189 5.74047 18.6811 6.00804Z"
                    fill="url(#paint0_linear_253_9)"/>
                <path
                    d="M13.5 0C6.05676 0 0 4.03784 0 9C0 13.9622 6.05676 18 13.5 18C20.9432 18 27 13.9622 27 9C27 4.03784 20.9432 0 13.5 0ZM13.5 16.5405C7.26081 16.5405 2.18919 13.1595 2.18919 9C2.18919 4.84054 7.26081 1.45946 13.5 1.45946C19.7392 1.45946 24.8108 4.84054 24.8108 9C24.8108 13.1595 19.7392 16.5405 13.5 16.5405Z"
                    fill="url(#paint1_linear_253_9)"/>
                <defs>
                  <linearGradient id="paint0_linear_253_9" gradientUnits="userSpaceOnUse" x1="13.5435" x2="13.5435" y1="5.74593"
                                  y2="12.5581">
                    <stop stop-color="white"/>
                    <stop offset="1" stop-color="#00ACEA"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_253_9" gradientUnits="userSpaceOnUse" x1="13.5" x2="13.5" y1="-0.182432"
                                  y2="19.1223">
                    <stop stop-color="white"/>
                    <stop offset="1" stop-color="#00ACEA"/>
                  </linearGradient>
                </defs>
              </svg>
            </i>
            Xác nhận đã nhận thông tin
          </b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-notices-detail-hot" hide-footer hide-header no-close-on-backdrop no-close-on-esc size="xl"
             title="">
      <b-row>
        <b-col class="new-detail" cols="12" md="12" sm="12" xs="12">
          <div v-if="Object.keys(currentItem).length > 0" class="text-left">
            <b-row class="text-right">
              <b-col md="9" sm="8" xs="12"></b-col>
              <b-col class="header-status" md="3" sm="4" xs="4">
                <b-form-group>
                  <label>Trạng thái: </label>
                  <label :class="currentItem.status == 1 ? 'status-1' : 'status-2'" class="ml-50">
                    {{ currentItem.status_name }}</label>
                </b-form-group>
                <div class="hr-bottom"></div>
              </b-col>
            </b-row>
            <b-row class="detail-tile">
              {{ currentItem.type_notice_name }} &#62; {{ currentItem.name }}
            </b-row>
            <b-row class="use-new">
              <b-col cols="12">
                <b-form-group>
                  <!-- eslint-disable vue/no-v-html -->
                  <div class="question-content" v-html="currentItem.contents"/>
                  <!-- eslint-enable -->
                </b-form-group>
              </b-col>
              <b-col v-if="currentItem.file_path && currentItem.file_path.length > 0" cols="12">
                <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                               @click="downloadFile(currentItem.file_path)">
                  <div class="sample-file__download">
                    <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                  </div>
                  {{ currentItem.file_path.split('/')[1] }}
                </b-input-group>
              </b-col>
            </b-row>
            <b-row class="text-right">
              <b-col md="8" sm="6" xs="12">
                <b-form-group>
                  <label>Ngày tạo: </label>
                  <label class="ml-50">
                    <b>{{this.dateFormat(currentItem.created_date) }}</b></label>
                </b-form-group>

              </b-col>
              <b-col md="4" sm="6" xs="12">
                <b-form-group>
                  <label>Người soạn: </label>
                  <label class="ml-50">
                    <b>{{ currentItem.created_at }}</b></label>
                </b-form-group>
                <div class="mt-1">&nbsp;</div>
              </b-col>
            </b-row>
            <b-row class="text-right">
              <b-col md="8" sm="6" xs="12">
                <b-form-group>
                  <label>Ngày sửa: </label>
                  <label class="ml-50">
                    <b>{{this.dateFormat(currentItem.updated_date) }}</b></label>
                </b-form-group>

              </b-col>
              <b-col v-if="currentItem.updated_at" md="4" sm="6" xs="12">
                <b-form-group>
                  <label>Người sửa: </label>
                  <label class="ml-50">
                    <b>{{ currentItem.updated_at }}</b></label>
                </b-form-group>
                <div class="mt-1">&nbsp;</div>
              </b-col>
            </b-row>
            <b-row class="text-center">
              <div class="mt-1">&nbsp;</div>
            </b-row>
            <b-col class="text-center  mt-50" cols="12">
              <b-button class="btn-sm mr-50 btn-confirm" variant="primary" @click="confirmNotices()">
                <i class="fa confirm-custom">
                  <svg fill="none" height="18" viewBox="0 0 27 18" width="27"
                       xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M18.6811 6.00804L11.7122 10.4351L8.39189 8.14858C7.95405 7.85669 7.26081 7.85669 6.85945 8.12425C6.42162 8.41615 6.42162 8.87831 6.82297 9.14587L10.9095 11.9432C11.1284 12.0891 11.4203 12.1621 11.6757 12.1621C11.9311 12.1621 12.223 12.0891 12.4419 11.9675L20.2135 7.05398C20.6513 6.78642 20.6878 6.32425 20.25 6.03236C19.8122 5.74047 19.1189 5.74047 18.6811 6.00804Z"
                        fill="url(#paint0_linear_253_9)"/>
                    <path
                        d="M13.5 0C6.05676 0 0 4.03784 0 9C0 13.9622 6.05676 18 13.5 18C20.9432 18 27 13.9622 27 9C27 4.03784 20.9432 0 13.5 0ZM13.5 16.5405C7.26081 16.5405 2.18919 13.1595 2.18919 9C2.18919 4.84054 7.26081 1.45946 13.5 1.45946C19.7392 1.45946 24.8108 4.84054 24.8108 9C24.8108 13.1595 19.7392 16.5405 13.5 16.5405Z"
                        fill="url(#paint1_linear_253_9)"/>
                    <defs>
                      <linearGradient id="paint0_linear_253_9" gradientUnits="userSpaceOnUse" x1="13.5435" x2="13.5435" y1="5.74593"
                                      y2="12.5581">
                        <stop stop-color="white"/>
                        <stop offset="1" stop-color="#00ACEA"/>
                      </linearGradient>
                      <linearGradient id="paint1_linear_253_9" gradientUnits="userSpaceOnUse" x1="13.5" x2="13.5" y1="-0.182432"
                                      y2="19.1223">
                        <stop stop-color="white"/>
                        <stop offset="1" stop-color="#00ACEA"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </i>
                Xác nhận đã nhận thông tin
              </b-button>
            </b-col>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-confirm-sucess-notices" centered hide-footer hide-header no-close-on-backdrop no-close-on-esc
             title="">
      <div class="confirm-notice" @click="noticeClose()">
        <svg fill="none" height="169" viewBox="0 0 687 169" width="687" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M49 29C49 17.9543 57.9543 9 69 9H667C678.046 9 687 17.9543 687 29V149C687 160.046 678.046 169 667 169H69C57.9543 169 49 160.046 49 149V29Z"
              fill="#FFAC60"/>
          <g filter="url(#filter0_d_253_9)">
            <path
                d="M162.837 76.0468C167.149 68.006 314.196 86.8051 331.335 78.9433C348.473 71.0814 280.46 39.8823 305.898 30.1171C331.335 20.3518 420.635 23.7447 420.635 30.1171C420.635 36.4894 395.706 68.0169 420.635 78.9433C445.564 89.8697 579.03 76.0468 567.304 84.6535C555.578 93.2601 591.201 141.06 585.344 146.638C579.488 152.216 179.982 138.312 162.837 146.638C145.692 154.963 148.479 102.816 162.837 76.0468Z"
                fill="white" stroke="#FFAC60"/>
            <g filter="url(#filter1_d_253_9)">
              <path
                  d="M360.5 39H364.5C369.194 39 373 42.8056 373 47.5C373 52.1944 369.194 56 364.5 56H360.5C355.806 56 352 52.1944 352 47.5C352 42.8056 355.806 39 360.5 39Z"
                  fill="#FF5A5A"/>
              <path
                  d="M360.5 39H364.5C369.194 39 373 42.8056 373 47.5C373 52.1944 369.194 56 364.5 56H360.5C355.806 56 352 52.1944 352 47.5C352 42.8056 355.806 39 360.5 39Z"
                  stroke="#FFAC60"/>
            </g>
          </g>
          <path
              d="M229.538 104H233.93V103.424L231.95 103.154H231.518L229.538 103.424V104ZM230.636 104H231.626L235.46 97.79L235.748 97.268H235.856L235.352 96.908L230.636 104ZM236.144 104H242.156V103.424L239.618 103.154H238.88L236.144 103.424V104ZM236.378 97.016L240.518 90.68H239.582L236.234 96.224L235.946 96.71H235.856L236.378 97.016ZM238.376 104H241.184L233.39 90.68H230.582L238.376 104ZM229.718 91.274L232.238 91.508H233.048L235.622 91.274V90.68H229.718V91.274ZM237.35 91.274L239.258 91.508H239.708L241.67 91.274V90.68H237.35V91.274ZM247.692 89.348L247.962 89.726C248.934 89.312 249.906 88.88 250.86 88.43C251.742 88.034 251.976 87.602 251.976 87.26C251.976 86.846 251.616 86.432 251.112 86.432C250.716 86.432 250.374 86.63 249.78 87.224C249.114 87.872 248.412 88.61 247.692 89.348ZM242.634 104H246.702V103.424L244.758 103.172H244.416L242.634 103.424V104ZM243.876 104H244.776L248.412 92.444L248.466 92.192H248.088L251.886 104H254.496L249.924 90.608H248.358L243.876 104ZM245.874 99.662H251.832L251.706 99.068H246L245.874 99.662ZM249.798 104H255.648V103.406L253.146 103.154H252.228L249.798 103.406V104ZM263.15 104.342C264.77 104.342 266.03 103.982 267.164 103.298L267.128 100.184H266.156L265.22 103.73L266.48 103.316V102.668C265.49 103.388 264.626 103.676 263.6 103.676C260.9 103.676 258.884 101.66 258.884 97.358C258.884 93.074 260.9 91.004 263.582 91.004C264.644 91.004 265.436 91.292 266.372 91.94V91.346L265.076 90.914L266.03 94.496H267.002L267.038 91.364C265.868 90.698 264.77 90.338 263.168 90.338C259.28 90.338 256.184 92.804 256.184 97.448C256.184 102.02 259.19 104.342 263.15 104.342ZM273.161 104H278.021V103.424L275.555 103.154H275.051L273.161 103.424V104ZM274.907 104H275.771V99.32L275.573 91.166H274.907V104ZM281.639 91.274L284.141 91.508H284.609L286.499 91.274V90.68H281.639V91.274ZM283.421 104.072H284.735V90.68H283.979V95.918L284.051 101.264L284.393 101.138L277.211 90.68H273.215V91.274L274.727 91.4L275.321 92.318L275.375 92.372L283.421 104.072ZM287.824 104H293.746V103.424L290.992 103.154H290.488L287.824 103.424V104ZM289.48 104H292.144C292.09 101.93 292.09 99.842 292.09 97.43V96.926C292.09 94.82 292.09 92.714 292.144 90.68H289.48C289.516 92.75 289.516 94.82 289.516 96.926V97.772C289.516 99.878 289.516 101.984 289.48 104ZM290.812 97.502H298.768V96.854H290.812V97.502ZM295.816 104H301.756V103.424L299.038 103.154H298.552L295.816 103.424V104ZM297.418 104H300.1C300.046 101.93 300.046 99.842 300.046 97.772V96.926C300.046 94.82 300.046 92.714 300.1 90.68H297.418C297.49 92.75 297.49 94.82 297.49 96.926V97.43C297.49 99.878 297.49 101.984 297.418 104ZM287.824 91.274L290.488 91.508H290.992L293.746 91.274V90.68H287.824V91.274ZM295.816 91.274L298.552 91.508H299.038L301.756 91.274V90.68H295.816V91.274ZM309.788 86.702H308.744L305.954 89.618L306.224 89.978L309.986 87.944H308.546L312.29 89.978L312.578 89.618L309.788 86.702ZM302.822 104H306.926V103.424L304.946 103.172H304.622L302.822 103.424V104ZM304.082 104H304.964L308.672 91.706L308.15 92.228L311.93 104H314.54L309.986 90.608H308.42L304.082 104ZM305.972 99.662H312.092L311.912 99.05H306.17L305.972 99.662ZM309.968 104H315.818V103.424L313.316 103.154H312.398L309.968 103.424V104ZM308.924 108.158C309.68 108.158 310.31 107.618 310.31 106.844C310.31 106.106 309.68 105.566 308.924 105.566C308.168 105.566 307.556 106.106 307.556 106.844C307.556 107.618 308.168 108.158 308.924 108.158ZM316.666 104H321.526V103.424L319.06 103.154H318.556L316.666 103.424V104ZM318.412 104H319.276V99.32L319.078 91.166H318.412V104ZM325.144 91.274L327.646 91.508H328.114L330.004 91.274V90.68H325.144V91.274ZM326.926 104.072H328.24V90.68H327.484V95.918L327.556 101.264L327.898 101.138L320.716 90.68H316.72V91.274L318.232 91.4L318.826 92.318L318.88 92.372L326.926 104.072ZM338.202 104H344.628V103.424L341.73 103.154H341.028L338.202 103.424V104ZM340.074 104H342.738C342.684 101.93 342.684 99.842 342.684 97.772V96.926C342.684 94.82 342.684 92.714 342.738 90.68H340.074C340.128 92.75 340.128 94.82 340.128 96.926V97.772C340.128 99.878 340.128 101.984 340.074 104ZM335.556 94.406H336.528L337.464 90.68L336.24 91.364H346.554L345.348 90.68L346.32 94.406H347.256L347.166 90.68H335.664L335.556 94.406ZM348.486 104H354.408V103.424L351.654 103.154H351.15L348.486 103.424V104ZM350.142 104H352.806C352.752 101.93 352.752 99.842 352.752 97.43V96.926C352.752 94.82 352.752 92.714 352.806 90.68H350.142C350.178 92.75 350.178 94.82 350.178 96.926V97.772C350.178 99.878 350.178 101.984 350.142 104ZM351.474 97.502H359.43V96.854H351.474V97.502ZM356.478 104H362.418V103.424L359.7 103.154H359.214L356.478 103.424V104ZM358.08 104H360.762C360.708 101.93 360.708 99.842 360.708 97.772V96.926C360.708 94.82 360.708 92.714 360.762 90.68H358.08C358.152 92.75 358.152 94.82 358.152 96.926V97.43C358.152 99.878 358.152 101.984 358.08 104ZM348.486 91.274L351.15 91.508H351.654L354.408 91.274V90.68H348.486V91.274ZM356.478 91.274L359.214 91.508H359.7L362.418 91.274V90.68H356.478V91.274ZM371.404 89.33C370.702 88.592 369.946 87.872 369.28 87.224C368.686 86.63 368.362 86.432 367.966 86.432C367.462 86.432 367.084 86.846 367.084 87.26C367.084 87.62 367.354 88.052 368.236 88.448C369.208 88.88 370.162 89.312 371.134 89.708L371.404 89.33ZM363.466 104H367.534V103.424L365.59 103.172H365.248L363.466 103.424V104ZM364.708 104H365.608L369.244 92.444L369.298 92.192H368.92L372.718 104H375.328L370.756 90.608H369.19L364.708 104ZM366.706 99.662H372.664L372.538 99.068H366.832L366.706 99.662ZM370.63 104H376.48V103.406L373.978 103.154H373.06L370.63 103.406V104ZM377.329 104H382.189V103.424L379.723 103.154H379.219L377.329 103.424V104ZM379.075 104H379.939V99.32L379.741 91.166H379.075V104ZM385.807 91.274L388.309 91.508H388.777L390.667 91.274V90.68H385.807V91.274ZM387.589 104.072H388.903V90.68H388.147V95.918L388.219 101.264L388.561 101.138L381.379 90.68H377.383V91.274L378.895 91.4L379.489 92.318L379.543 92.372L387.589 104.072ZM391.992 104H397.914V103.424L395.16 103.154H394.656L391.992 103.424V104ZM393.648 104H396.312C396.258 101.93 396.258 99.842 396.258 97.43V96.926C396.258 94.82 396.258 92.714 396.312 90.68H393.648C393.684 92.75 393.684 94.82 393.684 96.926V97.772C393.684 99.878 393.684 101.984 393.648 104ZM394.98 97.502H402.936V96.854H394.98V97.502ZM399.984 104H405.924V103.424L403.206 103.154H402.72L399.984 103.424V104ZM401.586 104H404.268C404.214 101.93 404.214 99.842 404.214 97.772V96.926C404.214 94.82 404.214 92.714 404.268 90.68H401.586C401.658 92.75 401.658 94.82 401.658 96.926V97.43C401.658 99.878 401.658 101.984 401.586 104ZM391.992 91.274L394.656 91.508H395.16L397.914 91.274V90.68H391.992V91.274ZM399.984 91.274L402.72 91.508H403.206L405.924 91.274V90.68H399.984V91.274ZM419.05 104.342C420.67 104.342 421.93 103.982 423.064 103.298L423.028 100.184H422.056L421.12 103.73L422.38 103.316V102.668C421.39 103.388 420.526 103.676 419.5 103.676C416.8 103.676 414.784 101.66 414.784 97.358C414.784 93.074 416.8 91.004 419.482 91.004C420.544 91.004 421.336 91.292 422.272 91.94V91.346L420.976 90.914L421.93 94.496H422.902L422.938 91.364C421.768 90.698 420.67 90.338 419.068 90.338C415.18 90.338 412.084 92.804 412.084 97.448C412.084 102.02 415.09 104.342 419.05 104.342ZM431.367 86.594H430.341L427.533 89.546L427.821 89.888L431.583 87.872H430.143L433.887 89.888L434.175 89.546L431.367 86.594ZM430.845 104.342C434.193 104.342 437.055 101.876 437.055 97.34C437.055 92.786 434.175 90.338 430.845 90.338C427.533 90.338 424.635 92.822 424.635 97.34C424.635 101.912 427.533 104.342 430.845 104.342ZM430.845 103.676C428.469 103.676 427.317 100.94 427.317 97.34C427.317 93.758 428.469 91.004 430.845 91.004C433.239 91.004 434.373 93.758 434.373 97.34C434.373 100.94 433.239 103.676 430.845 103.676ZM438.342 104H443.202V103.424L440.736 103.154H440.232L438.342 103.424V104ZM440.088 104H440.952V99.32L440.754 91.166H440.088V104ZM446.82 91.274L449.322 91.508H449.79L451.68 91.274V90.68H446.82V91.274ZM448.602 104.072H449.916V90.68H449.16V95.918L449.232 101.264L449.574 101.138L442.392 90.68H438.396V91.274L439.908 91.4L440.502 92.318L440.556 92.372L448.602 104.072ZM459.849 104.342C461.523 104.342 462.765 103.982 464.169 103.172V102.272C464.169 100.526 464.205 99.014 464.241 97.52H461.685C461.721 99.122 461.757 100.616 461.757 102.2V103.676L462.621 103.136C461.811 103.496 461.037 103.676 460.137 103.676C457.509 103.676 455.583 101.282 455.583 97.34C455.583 93.146 457.599 91.004 460.281 91.004C461.397 91.004 462.171 91.31 463.179 92.12V91.382L461.883 90.896L462.801 94.496H463.827L463.845 91.328C462.729 90.698 461.523 90.338 459.957 90.338C455.763 90.338 452.883 93.056 452.883 97.304C452.883 101.66 455.691 104.342 459.849 104.342ZM459.723 98.096L462.225 98.366H463.233L465.393 98.096V97.52H459.723V98.096ZM194.586 130.342C196.206 130.342 197.466 129.982 198.6 129.298L198.564 126.184H197.592L196.656 129.73L197.916 129.316V128.668C196.926 129.388 196.062 129.676 195.036 129.676C192.336 129.676 190.32 127.66 190.32 123.358C190.32 119.074 192.336 117.004 195.018 117.004C196.08 117.004 196.872 117.292 197.808 117.94V117.346L196.512 116.914L197.466 120.496H198.438L198.474 117.364C197.304 116.698 196.206 116.338 194.604 116.338C190.716 116.338 187.62 118.804 187.62 123.448C187.62 128.02 190.626 130.342 194.586 130.342ZM200.097 130H205.029V129.478L203.139 129.28H201.987L200.097 129.478V130ZM201.375 130H203.913C203.859 129.1 203.841 127.03 203.841 125.788V122.278L203.805 122.044V118.3L203.859 115.438L203.607 115.276L200.007 115.96V116.446L201.429 116.554V125.788C201.429 127.03 201.411 129.1 201.375 130ZM206.325 130H211.257V129.478L209.313 129.28H208.179L206.325 129.478V130ZM207.549 130H210.105C210.051 129.1 210.033 127.084 210.033 125.788V123.556C210.033 121.09 208.935 120.082 207.243 120.082C205.821 120.082 204.723 120.748 203.481 122.332H202.743L203.265 123.088C204.363 121.828 205.389 121.288 206.181 121.288C207.063 121.288 207.621 121.828 207.621 123.358V125.788C207.621 127.084 207.603 129.1 207.549 130ZM216.308 130.306C217.82 130.306 219.026 129.406 219.908 128.146H220.772L220.16 127.246C219.458 128.236 218.522 128.938 217.496 128.938C216.524 128.938 215.93 128.416 215.93 126.814V123.016L216.038 120.388L215.822 120.19L212.222 120.64V121.126L214.076 121.45L213.554 121.054L213.5 126.634C213.464 129.334 214.544 130.306 216.308 130.306ZM219.764 130.234L223.328 130.018V129.496L222.104 129.37V123.016L222.176 120.388L221.978 120.19L218.432 120.712V121.126L219.728 121.342L219.674 128.002V128.038L219.764 130.234ZM216.56 118.426L216.938 118.714C217.55 118.192 218.198 117.688 219.278 116.95C220.034 116.446 220.34 115.978 220.34 115.51C220.34 114.952 219.908 114.628 219.494 114.628C218.972 114.628 218.612 114.952 218.18 115.708C217.46 116.932 217.01 117.67 216.56 118.426ZM229.443 130.306C231.369 130.306 232.539 129.568 233.385 128.056L233.061 127.822C232.395 128.686 231.513 129.154 230.469 129.154C228.471 129.154 227.157 127.642 227.157 125.014C227.157 122.278 228.417 120.676 230.091 120.676C230.721 120.676 231.297 120.856 231.981 121.252L230.757 120.46L231.081 122.152C231.153 123.232 231.675 123.61 232.341 123.61C232.881 123.61 233.223 123.34 233.385 122.764C233.115 121.216 231.657 120.082 229.821 120.082C226.995 120.082 224.601 121.918 224.601 125.338C224.601 128.524 226.725 130.306 229.443 130.306ZM239.261 130L242.627 130.252L243.005 128.614V121.828L242.969 121.648V118.3L243.023 115.438L242.771 115.276L239.171 115.96V116.446L240.593 116.554V125.788C240.593 126.796 240.575 128.326 240.557 129.37L239.261 129.478V130ZM245.813 130.306C248.243 130.306 249.953 128.074 249.953 125.14C249.953 121.9 248.261 120.082 246.029 120.082C244.697 120.082 243.455 120.676 242.447 122.044H242.105L242.339 122.566C243.419 121.36 244.121 121.18 244.877 121.18C246.317 121.18 247.361 122.314 247.361 125.086C247.361 128.29 246.173 129.172 244.823 129.172C244.067 129.172 243.419 128.884 242.717 128.092L242.393 128.398H242.591C243.455 129.694 244.589 130.306 245.813 130.306ZM251.357 127.894C251.357 129.406 252.437 130.306 253.931 130.306C255.389 130.306 256.109 129.676 257.153 128.524L257.783 127.804L257.675 127.498L257.045 128.092C256.199 128.884 255.695 129.19 255.083 129.19C254.165 129.19 253.607 128.668 253.607 127.57C253.607 126.382 254.237 125.554 255.605 125.014C256.163 124.798 257.243 124.51 258.215 124.276V123.808C257.243 124.042 255.911 124.366 254.975 124.636C252.257 125.464 251.357 126.346 251.357 127.894ZM258.971 130.288C259.979 130.288 260.591 129.928 261.023 129.064L260.735 128.812C260.393 129.28 260.195 129.406 259.925 129.406C259.529 129.406 259.295 129.136 259.295 128.308V123.592C259.295 121.108 258.287 120.082 255.875 120.082C253.355 120.082 251.861 121.09 251.663 122.71C251.771 123.232 252.167 123.538 252.743 123.538C253.337 123.538 253.841 123.124 253.913 122.098L254.111 120.712L252.977 121.18C253.841 120.802 254.453 120.676 255.065 120.676C256.451 120.676 256.955 121.234 256.955 123.142V128.326C257.099 129.532 257.747 130.288 258.971 130.288ZM255.713 134.158C256.469 134.158 257.099 133.618 257.099 132.844C257.099 132.106 256.469 131.566 255.713 131.566C254.975 131.566 254.345 132.106 254.345 132.844C254.345 133.618 254.975 134.158 255.713 134.158ZM261.742 130H266.692V129.478L264.784 129.28H263.65L261.742 129.478V130ZM263.02 130H265.558C265.522 129.1 265.504 127.03 265.504 125.788V122.296L265.378 120.262L265.144 120.1L261.616 121.09V121.54L263.02 121.666C263.056 122.53 263.074 123.232 263.074 124.42V125.788C263.074 127.03 263.056 129.1 263.02 130ZM267.97 130H272.902V129.478L270.958 129.28H269.842L267.97 129.478V130ZM269.212 130H271.75C271.714 129.1 271.678 127.084 271.678 125.788V123.52C271.678 121.144 270.58 120.082 268.924 120.082C267.61 120.082 266.458 120.64 265.108 122.35H264.838L264.928 123.106C266.026 121.828 267.142 121.288 267.88 121.288C268.78 121.288 269.266 121.828 269.266 123.358V125.788C269.266 127.084 269.248 129.1 269.212 130ZM279.861 118.048V118.678L282.165 118.408V125.788C282.165 127.156 282.147 128.596 282.111 130H284.685C284.631 128.596 284.613 127.156 284.613 125.788V120.082L284.685 117.166L284.415 116.968L279.861 118.048ZM284.523 129.154H282.291L279.465 129.478V130H287.169V129.478L284.523 129.154ZM293.647 130H298.597V129.478L296.689 129.28H295.555L293.647 129.478V130ZM294.925 130H297.463C297.427 129.1 297.409 127.03 297.409 125.788V122.296L297.283 120.262L297.049 120.1L293.521 121.09V121.54L294.925 121.666C294.961 122.53 294.979 123.232 294.979 124.42V125.788C294.979 127.03 294.961 129.1 294.925 130ZM299.875 130H304.807V129.478L302.863 129.28H301.747L299.875 129.478V130ZM301.117 130H303.655C303.619 129.1 303.583 127.084 303.583 125.788V123.52C303.583 121.144 302.485 120.082 300.829 120.082C299.515 120.082 298.363 120.64 297.013 122.35H296.743L296.833 123.106C297.931 121.828 299.047 121.288 299.785 121.288C300.685 121.288 301.171 121.828 301.171 123.358V125.788C301.171 127.084 301.153 129.1 301.117 130ZM309.911 134.68C313.511 134.68 315.545 132.862 315.545 131.008C315.545 129.442 314.483 128.38 311.801 128.38H309.155C308.201 128.38 307.805 128.02 307.805 127.444C307.805 126.886 308.021 126.526 308.489 125.932L308.147 125.752V125.914C306.851 126.796 306.419 127.588 306.419 128.416C306.419 129.28 306.923 129.874 307.895 130.162V130.216C308.399 130.378 308.867 130.396 309.785 130.396H311.855C313.169 130.396 313.601 131.08 313.601 131.728C313.601 133.06 312.377 133.924 309.929 133.924C308.291 133.924 307.337 133.24 307.337 131.926C307.337 131.116 307.679 130.666 308.363 130L308.309 129.874C306.653 130.45 305.861 131.296 305.861 132.304C305.861 133.618 306.797 134.68 309.911 134.68ZM310.235 126.598C312.827 126.598 314.177 125.23 314.177 123.358C314.177 122.494 313.907 121.738 313.385 121.198L313.313 121.126C312.683 120.478 311.657 120.082 310.253 120.082C307.625 120.082 306.275 121.432 306.275 123.358C306.275 125.23 307.625 126.598 310.235 126.598ZM310.235 126.04C309.101 126.04 308.471 124.996 308.471 123.358C308.471 121.666 309.137 120.64 310.253 120.64C311.333 120.64 312.017 121.648 312.017 123.358C312.017 124.996 311.351 126.04 310.235 126.04ZM312.719 121.324L315.707 121.558V120.298L315.383 120.1L312.827 121.036H312.719V121.324ZM319.128 130.306C320.586 130.306 321.306 129.676 322.35 128.524H322.98L322.71 127.57C321.486 128.884 320.856 129.19 320.28 129.19C319.398 129.19 318.804 128.65 318.804 127.57C318.804 126.364 319.47 125.554 320.766 125.032C321.396 124.798 322.44 124.528 323.412 124.276V123.808C322.44 124.042 321.126 124.366 320.19 124.654C317.436 125.41 316.554 126.328 316.554 127.894C316.554 129.406 317.634 130.306 319.128 130.306ZM324.168 130.288C325.176 130.288 325.806 129.91 326.238 129.046L325.932 128.794C325.608 129.262 325.41 129.406 325.122 129.406C324.726 129.406 324.528 129.136 324.528 128.308V123.592C324.528 121.108 323.484 120.082 321.09 120.082C318.552 120.082 317.058 121.09 316.842 122.692C316.968 123.232 317.364 123.52 317.94 123.52C318.534 123.52 319.056 123.142 319.11 122.098L319.308 120.712L318.174 121.162C319.038 120.82 319.65 120.676 320.28 120.676C321.666 120.676 322.152 121.234 322.152 123.142V128.326C322.296 129.532 322.926 130.288 324.168 130.288ZM321.936 118.426C321.504 117.688 321.036 116.932 320.37 115.69C319.938 114.934 319.542 114.628 319.02 114.628C318.606 114.628 318.156 114.952 318.156 115.51C318.156 115.978 318.552 116.428 319.29 116.95C320.334 117.67 320.946 118.192 321.576 118.714L321.936 118.426ZM327.775 134.878C329.269 134.878 330.475 133.834 331.627 130.774L335.497 120.37H334.759L333.301 124.798L331.717 129.118L331.573 129.55L331.015 130.846C330.277 132.682 329.539 133.762 328.405 134.248L328.747 134.554L329.377 134.14L328.837 133.492C328.405 132.988 327.919 132.61 327.289 132.61C326.641 132.61 326.029 132.934 325.903 133.636C325.957 134.41 326.839 134.878 327.775 134.878ZM331.141 131.314L332.239 128.452L332.131 128.254L329.251 120.37H326.623L331.141 131.314ZM325.867 120.892L327.685 121.09H329.233L331.015 120.892V120.37H325.867V120.892ZM332.761 120.892L334.651 121.072H334.975L336.451 120.892V120.37H332.761V120.892ZM341.581 130H346.819V129.478L344.731 129.28H343.597L341.581 129.478V130ZM342.949 130H345.487C345.433 128.758 345.415 127.138 345.415 125.788V118.3L345.487 115.438L345.217 115.276L341.581 115.96V116.446L343.003 116.554V125.788C343.003 127.138 342.985 128.758 342.949 130ZM350.593 130.306C352.051 130.306 352.771 129.676 353.815 128.524H354.445L354.175 127.57C352.951 128.884 352.321 129.19 351.745 129.19C350.863 129.19 350.269 128.65 350.269 127.57C350.269 126.364 350.935 125.554 352.231 125.032C352.861 124.798 353.905 124.528 354.877 124.276V123.808C353.905 124.042 352.591 124.366 351.655 124.654C348.901 125.41 348.019 126.328 348.019 127.894C348.019 129.406 349.099 130.306 350.593 130.306ZM355.633 130.288C356.641 130.288 357.271 129.91 357.703 129.046L357.397 128.794C357.073 129.262 356.875 129.406 356.587 129.406C356.191 129.406 355.993 129.136 355.993 128.308V123.592C355.993 121.108 354.949 120.082 352.555 120.082C350.017 120.082 348.523 121.09 348.307 122.692C348.433 123.232 348.829 123.52 349.405 123.52C349.999 123.52 350.521 123.142 350.575 122.098L350.773 120.712L349.639 121.162C350.503 120.82 351.115 120.676 351.745 120.676C353.131 120.676 353.617 121.234 353.617 123.142V128.326C353.761 129.532 354.391 130.288 355.633 130.288ZM353.401 118.426C352.969 117.688 352.501 116.932 351.835 115.69C351.403 114.934 351.007 114.628 350.485 114.628C350.071 114.628 349.621 114.952 349.621 115.51C349.621 115.978 350.017 116.428 350.755 116.95C351.799 117.67 352.411 118.192 353.041 118.714L353.401 118.426ZM358.404 130H363.354V129.478L361.446 129.28H360.312L358.404 129.478V130ZM359.682 130H362.22C362.184 129.1 362.166 127.03 362.166 125.788V122.242L362.04 120.262L361.806 120.1L358.278 121.09V121.522L359.682 121.648C359.736 122.53 359.736 123.214 359.736 124.402V125.788C359.736 127.03 359.718 129.1 359.682 130ZM364.506 130H369.366V129.478L367.494 129.28H366.342L364.506 129.478V130ZM365.73 130H368.232C368.196 129.1 368.16 127.084 368.16 125.788V123.52C368.16 121.144 367.206 120.082 365.46 120.082C364.002 120.082 362.868 120.892 361.806 122.35H361.518L361.608 123.178C362.562 122.008 363.552 121.306 364.452 121.306C365.352 121.306 365.802 121.918 365.802 123.484V125.788C365.802 127.084 365.784 129.1 365.73 130ZM370.536 130H375.396V129.478L373.488 129.28H372.3L370.536 129.478V130ZM371.742 130H374.226C374.19 129.1 374.172 127.084 374.172 125.788V123.592C374.172 121.144 373.254 120.082 371.364 120.082C370.032 120.082 368.88 120.694 367.8 122.206H367.458L367.566 123.124C368.592 121.882 369.528 121.306 370.41 121.306C371.328 121.306 371.796 121.81 371.796 123.484V125.788C371.796 127.084 371.778 129.1 371.742 130ZM384.969 130.072H386.031L389.703 120.37H388.893L386.319 127.948L386.211 128.2H386.589L383.673 120.37H381.009L384.969 130.072ZM380.235 120.892L381.999 121.108H383.511L385.401 120.892V120.37H380.235V120.892ZM387.183 120.892L388.893 121.108H389.253L390.711 120.892V120.37H387.183V120.892ZM391.523 130H396.491V129.478L394.547 129.28H393.431L391.523 129.478V130ZM392.783 130H395.339C395.285 129.1 395.267 127.03 395.267 125.788V123.034L395.321 120.262L395.105 120.1L391.361 121.054V121.504L392.783 121.612C392.819 122.476 392.837 123.268 392.837 124.456V125.788C392.837 127.03 392.819 129.1 392.783 130ZM393.953 118.21C394.727 118.21 395.339 117.67 395.339 116.896C395.339 116.14 394.727 115.582 393.953 115.582C393.197 115.582 392.585 116.14 392.585 116.896C392.585 117.67 393.197 118.21 393.953 118.21ZM402.713 120.082C400.229 120.082 397.799 121.9 397.799 125.158C397.799 128.488 399.941 130.306 402.731 130.306C404.477 130.306 405.863 129.46 406.601 128.038L406.277 127.804C405.647 128.632 404.837 129.154 403.577 129.154C401.795 129.154 400.355 127.894 400.355 124.888C400.355 121.99 401.345 120.676 402.551 120.676C403.685 120.676 404.441 121.63 404.441 123.16C404.441 124.15 404.243 124.528 403.469 124.528L398.861 124.492V125.14H406.601C406.691 124.816 406.709 124.492 406.709 124.06C406.709 121.828 405.287 120.082 402.713 120.082ZM405.287 118.894L405.647 118.57L403.127 115.078H402.137L399.635 118.57L399.995 118.894L403.343 116.23H401.939L405.287 118.894ZM402.479 134.158C403.235 134.158 403.847 133.618 403.847 132.844C403.847 132.106 403.235 131.566 402.479 131.566C401.723 131.566 401.111 132.106 401.111 132.844C401.111 133.618 401.723 134.158 402.479 134.158ZM412.941 130.306C414.867 130.306 416.037 129.568 416.883 128.056L416.559 127.822C415.893 128.686 415.011 129.154 413.967 129.154C411.969 129.154 410.655 127.642 410.655 125.014C410.655 122.278 411.915 120.676 413.589 120.676C414.219 120.676 414.795 120.856 415.479 121.252L414.255 120.46L414.579 122.152C414.651 123.232 415.173 123.61 415.839 123.61C416.379 123.61 416.721 123.34 416.883 122.764C416.613 121.216 415.155 120.082 413.319 120.082C410.493 120.082 408.099 121.918 408.099 125.338C408.099 128.524 410.223 130.306 412.941 130.306ZM422.759 130H427.691V129.478L425.801 129.28H424.649L422.759 129.478V130ZM424.037 130H426.575C426.521 129.1 426.503 127.03 426.503 125.788V122.278L426.467 122.044V118.3L426.521 115.438L426.269 115.276L422.669 115.96V116.446L424.091 116.554V125.788C424.091 127.03 424.073 129.1 424.037 130ZM428.987 130H433.919V129.478L431.975 129.28H430.841L428.987 129.478V130ZM430.211 130H432.767C432.713 129.1 432.695 127.084 432.695 125.788V123.556C432.695 121.09 431.597 120.082 429.905 120.082C428.483 120.082 427.385 120.748 426.143 122.332H425.405L425.927 123.088C427.025 121.828 428.051 121.288 428.843 121.288C429.725 121.288 430.283 121.828 430.283 123.358V125.788C430.283 127.084 430.265 129.1 430.211 130ZM435.135 130H440.103V129.478L438.159 129.28H437.043L435.135 129.478V130ZM436.395 130H438.951C438.897 129.1 438.879 127.03 438.879 125.788V123.034L438.933 120.262L438.717 120.1L434.973 121.054V121.504L436.395 121.612C436.431 122.476 436.449 123.268 436.449 124.456V125.788C436.449 127.03 436.431 129.1 436.395 130ZM437.565 118.21C438.339 118.21 438.951 117.67 438.951 116.896C438.951 116.14 438.339 115.582 437.565 115.582C436.809 115.582 436.197 116.14 436.197 116.896C436.197 117.67 436.809 118.21 437.565 118.21ZM446.324 120.082C443.84 120.082 441.41 121.9 441.41 125.158C441.41 128.488 443.552 130.306 446.342 130.306C448.088 130.306 449.474 129.46 450.212 128.038L449.888 127.804C449.258 128.632 448.448 129.154 447.188 129.154C445.406 129.154 443.966 127.894 443.966 124.888C443.966 121.99 444.956 120.676 446.162 120.676C447.296 120.676 448.052 121.63 448.052 123.16C448.052 124.15 447.854 124.528 447.08 124.528L442.472 124.492V125.14H450.212C450.302 124.816 450.32 124.492 450.32 124.06C450.32 121.828 448.898 120.082 446.324 120.082ZM448.898 118.894L449.258 118.57L446.738 115.078H445.748L443.246 118.57L443.606 118.894L446.954 116.23H445.55L448.898 118.894ZM446.09 134.158C446.846 134.158 447.458 133.618 447.458 132.844C447.458 132.106 446.846 131.566 446.09 131.566C445.334 131.566 444.722 132.106 444.722 132.844C444.722 133.618 445.334 134.158 446.09 134.158ZM455.599 130.306C457.111 130.306 458.317 129.406 459.199 128.146H460.063L459.451 127.246C458.749 128.236 457.813 128.938 456.787 128.938C455.815 128.938 455.221 128.416 455.221 126.814V123.016L455.329 120.388L455.113 120.19L451.513 120.64V121.126L453.367 121.45L452.845 121.054L452.791 126.634C452.755 129.334 453.835 130.306 455.599 130.306ZM459.055 130.234L462.619 130.018V129.496L461.395 129.37V123.016L461.467 120.388L461.269 120.19L457.723 120.712V121.126L459.019 121.342L458.965 128.002V128.038L459.055 130.234ZM473.81 134.68H479.03V134.158L477.158 133.978H475.736L473.81 134.158V134.68ZM472.424 130.306C473.72 130.306 474.854 129.73 475.736 128.488H475.862L475.628 128.2C474.944 128.902 474.368 129.172 473.594 129.172C472.082 129.172 471.002 128.11 471.002 125.266C471.002 122.314 472.118 121.18 473.594 121.18C474.332 121.18 474.962 121.45 475.646 122.152L475.934 121.864L475.844 121.81C475.088 120.622 474.008 120.082 472.856 120.082C470.354 120.082 468.41 122.08 468.41 125.302C468.41 128.434 470.12 130.306 472.424 130.306ZM475.304 134.68H477.806C477.752 133.276 477.734 131.872 477.734 130.45V123.016L477.806 120.28L477.518 120.136L475.304 121.63V128.56L475.376 128.776V130.45C475.376 131.872 475.358 133.276 475.304 134.68ZM483.777 130.306C485.289 130.306 486.495 129.406 487.377 128.146H488.241L487.629 127.246C486.927 128.236 485.991 128.938 484.965 128.938C483.993 128.938 483.399 128.416 483.399 126.814V123.016L483.507 120.388L483.291 120.19L479.691 120.64V121.126L481.545 121.45L481.023 121.054L480.969 126.634C480.933 129.334 482.013 130.306 483.777 130.306ZM487.233 130.234L490.797 130.018V129.496L489.573 129.37V123.016L489.645 120.388L489.447 120.19L485.901 120.712V121.126L487.197 121.342L487.143 128.002V128.038L487.233 130.234ZM492.16 127.894C492.16 129.406 493.24 130.306 494.734 130.306C496.192 130.306 496.912 129.676 497.956 128.524L498.586 127.804L498.478 127.498L497.848 128.092C497.002 128.884 496.498 129.19 495.886 129.19C494.968 129.19 494.41 128.668 494.41 127.57C494.41 126.382 495.04 125.554 496.408 125.014C496.966 124.798 498.046 124.51 499.018 124.276V123.808C498.046 124.042 496.714 124.366 495.778 124.636C493.06 125.464 492.16 126.346 492.16 127.894ZM499.774 130.288C500.782 130.288 501.394 129.928 501.826 129.064L501.538 128.812C501.196 129.28 500.998 129.406 500.728 129.406C500.332 129.406 500.098 129.136 500.098 128.308V123.592C500.098 121.108 499.09 120.082 496.678 120.082C494.158 120.082 492.664 121.09 492.466 122.71C492.574 123.232 492.97 123.538 493.546 123.538C494.14 123.538 494.644 123.124 494.716 122.098L494.914 120.712L493.78 121.18C494.644 120.802 495.256 120.676 495.868 120.676C497.254 120.676 497.758 121.234 497.758 123.142V128.326C497.902 129.532 498.55 130.288 499.774 130.288ZM496.426 118.93C497.848 118.768 498.55 118.012 498.55 116.986C498.55 115.654 497.704 114.88 495.814 114.7L495.652 116.248C497.092 116.464 497.56 116.698 497.56 117.346C497.56 117.886 497.308 118.21 496.318 118.48L496.426 118.93ZM505.013 130.27C505.877 130.27 506.525 129.622 506.525 128.794C506.525 127.984 505.877 127.336 505.013 127.336C504.167 127.336 503.519 127.984 503.519 128.794C503.519 129.622 504.167 130.27 505.013 130.27ZM505.013 116.392C504.113 116.392 503.555 116.914 503.555 117.886C503.555 118.786 503.789 120.136 504.365 122.764L504.725 125.572H505.283L505.661 122.764C506.237 120.136 506.471 118.786 506.471 117.886C506.471 116.914 505.895 116.392 505.013 116.392Z"
              fill="#66D54A"/>
          <g clip-path="url(#clip0_253_9)">
            <path
                d="M540 132C553.807 132 565 123.941 565 114C565 104.059 553.807 96 540 96C526.193 96 515 104.059 515 114C515 123.941 526.193 132 540 132Z"
                fill="#FFDD67"/>
            <path
                d="M540 124.814C536.993 124.815 534.06 124.14 531.611 122.883C529.161 121.627 527.317 119.852 526.334 117.806C526.251 117.651 526.212 117.486 526.219 117.32C526.227 117.154 526.28 116.992 526.377 116.841C526.474 116.691 526.612 116.556 526.782 116.444C526.953 116.333 527.153 116.248 527.371 116.193C527.588 116.139 527.819 116.117 528.049 116.128C528.279 116.139 528.503 116.184 528.708 116.259C528.914 116.334 529.096 116.438 529.244 116.565C529.393 116.692 529.504 116.839 529.571 116.997C530.317 118.562 531.723 119.92 533.593 120.881C535.463 121.842 537.703 122.359 540 122.359C542.297 122.359 544.537 121.842 546.407 120.881C548.277 119.92 549.683 118.562 550.429 116.997C550.496 116.839 550.607 116.692 550.756 116.565C550.904 116.438 551.086 116.334 551.292 116.259C551.497 116.184 551.721 116.139 551.951 116.128C552.181 116.117 552.412 116.139 552.629 116.193C552.847 116.248 553.047 116.333 553.218 116.444C553.388 116.556 553.526 116.691 553.623 116.841C553.72 116.992 553.773 117.154 553.781 117.32C553.788 117.486 553.749 117.651 553.666 117.806C552.683 119.852 550.839 121.627 548.389 122.883C545.94 124.14 543.007 124.815 540 124.814V124.814Z"
                fill="#B26D3C"/>
            <path
                d="M548.286 108.09C545.143 108.09 542.603 111.511 542.603 110.204C542.603 108.898 545.146 105.601 548.286 105.601C551.426 105.601 553.971 108.892 553.971 110.204C553.971 111.517 551.426 108.09 548.286 108.09V108.09Z"
                fill="#B26D3C"/>
            <path
                d="M531.714 108.003C528.571 108.003 526.029 111.427 526.029 110.12C526.029 108.814 528.574 105.516 531.714 105.516C534.854 105.516 537.397 108.808 537.397 110.12C537.397 111.433 534.854 108.003 531.714 108.003Z"
                fill="#B26D3C"/>
          </g>
          <path
              d="M207.744 94.1158L198.14 99.359L193.565 96.651C192.961 96.3053 192.006 96.3053 191.453 96.6222C190.849 96.9679 190.849 97.5152 191.403 97.8321L197.034 101.145C197.336 101.318 197.738 101.404 198.09 101.404C198.442 101.404 198.844 101.318 199.146 101.174L209.856 95.3546C210.459 95.0377 210.509 94.4903 209.906 94.1446C209.303 93.7989 208.347 93.7989 207.744 94.1158Z"
              fill="url(#paint0_linear_253_9)"/>
          <path
              d="M200.604 87C190.347 87 182 91.7823 182 97.6593C182 103.536 190.347 108.319 200.604 108.319C210.861 108.319 219.208 103.536 219.208 97.6593C219.208 91.7823 210.861 87 200.604 87ZM200.604 106.59C192.006 106.59 185.017 102.586 185.017 97.6593C185.017 92.733 192.006 88.7285 200.604 88.7285C209.202 88.7285 216.191 92.733 216.191 97.6593C216.191 102.586 209.202 106.59 200.604 106.59Z"
              fill="url(#paint1_linear_253_9)"/>
          <ellipse cx="37.5" cy="8.5" fill="#46C4BC" rx="14.5" ry="8.5"/>
          <ellipse cx="14" cy="35" fill="#D11F3F" rx="12" ry="15"/>
          <ellipse cx="54.5" cy="89.5" fill="#B26D3C" rx="9.5" ry="12.5"/>
          <ellipse cx="55.5" cy="51" fill="#D9D9D9" rx="7.5" ry="4"/>
          <ellipse cx="36" cy="64.5" fill="#2467E8" rx="6" ry="9.5"/>
          <path
              d="M83.8273 53.531C83.8273 64.8528 70.8436 74.031 54.8273 74.031C38.811 74.031 42.3274 44.3541 42.3274 33.0323C42.3274 21.7104 38.811 33.031 54.8273 33.031C70.8436 33.031 83.8273 42.2092 83.8273 53.531Z"
              fill="#FF5A5A"/>
          <ellipse cx="112" cy="24.5" fill="#8588D1" rx="6" ry="4.5"/>
          <circle cx="85.5" cy="76.5" fill="#2D45C5" r="3.5"/>
          <ellipse cx="77.5" cy="92.5" fill="#A5D798" rx="0.5" ry="1.5"/>
          <ellipse cx="109.5" cy="60" fill="#FE1B1B" rx="2.5" ry="5"/>
          <ellipse cx="89.5" cy="96.5" fill="#9D0909" rx="5.5" ry="10.5"/>
          <ellipse cx="9" cy="67" fill="#FFDD67" rx="9" ry="13"/>
          <circle cx="78" cy="21" fill="white" r="4"/>
          <circle cx="92.5" cy="39.5" fill="#A75252" r="2.5"/>
          <ellipse cx="93.5" cy="59" fill="#683535" rx="1.5" ry="1"/>
          <ellipse cx="70" cy="102.5" fill="#440C0C" rx="1" ry="4.5"/>
          <ellipse cx="32.5" cy="28" fill="#382828" rx="3.5" ry="1"/>
          <defs>
            <filter id="filter0_d_253_9" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="133" width="444" x="146.5"
                    y="23.5">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
                             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_253_9"/>
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_253_9" mode="normal" result="shape"/>
            </filter>
            <filter id="filter1_d_253_9" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="26" width="30" x="347.5"
                    y="38.5">
              <feFlood flood-opacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
                             values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
              <feOffset dy="4"/>
              <feGaussianBlur stdDeviation="2"/>
              <feComposite in2="hardAlpha" operator="out"/>
              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
              <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_253_9"/>
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_253_9" mode="normal" result="shape"/>
            </filter>
            <linearGradient id="paint0_linear_253_9" gradientUnits="userSpaceOnUse" x1="200.664" x2="200.664" y1="86.7839"
                            y2="109.648">
              <stop stop-color="#70D755"/>
              <stop offset="1" stop-color="#00ACEA"/>
            </linearGradient>
            <linearGradient id="paint1_linear_253_9" gradientUnits="userSpaceOnUse" x1="200.604" x2="200.604" y1="86.7839"
                            y2="109.648">
              <stop stop-color="#66D44A"/>
              <stop offset="1" stop-color="#00ACEA"/>
            </linearGradient>
            <clipPath id="clip0_253_9">
              <rect fill="white" height="36" transform="translate(515 96)" width="50"/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BForm,
  BInputGroup,
  BFormInput,
  BCardText,
  BInputGroupPrepend,
  BTabs,
  BTab,
  BListGroup,
  BListGroupItem,
  BFormGroup,
  BFormFile,
  BButton,
  BFormTextarea, BFormCheckbox, BCollapse, VBToggle
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

const imgUrl = require("@/assets/images/illustration/marketing.svg");
import {getuserName} from '@/@core/utils/utils';
import {VueGoodTable} from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import moment from "moment";
import VJstree from 'vue-jstree'
import Vue from 'vue';

Vue.directive('b-toggle', VBToggle)

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTabs,
    BTab,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    VueGoodTable,
    VJstree,
    BFormFile,
    BButton,
    BFormTextarea,
    BCollapse, BFormCheckbox
  },

  data() {
    return {
      imgUrl: imgUrl,
      tabActive: 1,
      searchQuery: '',
      categoryList: [],
      categoryHonors: [],
      listHotNews: [],
      listNotices: [],
      searchHot: "",
      listNews: [],
      listHonors: [],
      currentItem: {},
      selected: 0,
      modal_title: "",
      totalRecords: 0,
      totalRecordHot: 0,
      totalNotices: 0,
      isLoading: false,
      smsItem: {},
      catSelects: [],
      item_active_id: -1,
      options: {
        fields: [
          {
            field: "topic_name",
            filterOptions: {enabled: false},
            label: "Danh mục",
            required: true
          },
          {
            field: "name",
            filterOptions: {enabled: false},
            label: "Chủ đề",
            required: true
          },
          {
            field: "reason",
            filterOptions: {enabled: false},
            label: "Lý do",
            required: true
          },
          {
            field: "updated_date",
            filterOptions: {enabled: false},
            label: "Ngày cập nhật",
            // type: 'date',
            // dateInputFormat: 'yyyy-MM-dd',
            // dateOutputFormat: 'dd/MM/yyyy',
            disabled: true
          }
        ],
        fieldNotice: [
          {
            field: "type_notice_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Loại thông báo",
            required: true,
            disabled: true,
          },
          {
            field: "name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Tiêu đề thông báo",
            required: true,
            disabled: true,
          },

          {
            field: "status_name",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Trạng thái",
            required: true,
            disabled: true,
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
    };
  },
  computed: {},
  mounted() {
    this.isSubmit = false;
    this.loadNotice(true);
    this.hotNew();
    this.loadCategories();
    // this.loadEmailConfig();
  },
  created() {
  },

  methods: {
    getTitle() {
      return this.modal_title;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.fetchHotNews();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.fetchHotNews();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.fetchHotNews();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      this.fetchHotNews();
    },

    quickSearch() {
      if (this.tabActive == 1) {
        this.fetchNews();
      } else if (this.tabActive == 2) {
        this.fetchHotNews();
      } else if (this.tabActive == 4) {
        this.loadNotice();
      } else {
        this.listHonors();
      }
    },

    fetchNews() {
      try {
        if (!this.searchQuery && this.item_active_id <= 0) {
          this.listNews = [];
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Bạn phải nhập thông tin tìm kiếm hoặc chọn chủ đề cần xem.',
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        this.loading(true);
        useJwt
            .get("portal/getListNews2?filter=" + this.searchQuery + '&topicIds=' + this.item_active_id)
            .then((response) => {
              if (response.data.code == 200) {
                this.listNews = response.data.result;
                for (var i = 0; i < this.listNews.length; i++) {
                  this.listNews[i]['Index'] = i + 1;
                }
                this.totalRecords = response.data.totalRecords;
              }
              this.isLoading = false;
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } catch {
        this.loading(false);
      }
    },
    fetchHotNews(day) {
      this.loading(true);
      if (!day) {
        day = 3650;
      }
      this.serverParams.columnFilters.lastDay = day;
      if (this.searchQuery) {
        this.serverParams.columnFilters.searchQuick = this.searchQuery;
      }

      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
        }
      }

      if (data.columnFilters.created_date != undefined) {
        delete data.columnFilters['created_date_']
      }
      useJwt
          .post("portal/HotNews2", data)
          .then((response) => {
            if (response.data.code == 200) {
              this.listHotNews = response.data.result;
              this.listHotNews.forEach((item, index) => {
                if(item.updated_date){
                  item.updated_date = moment(item.updated_date).format("DD/MM/YYYY");
                }
              });
              this.totalRecordHot = response.data.totalRecords;
            }
            this.isLoading = false;
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },

    changeTab(tab) {
      this.tabActive = tab;
      if (this.tabActive == 1) {
        this.fetchNews();
      } else if (this.tabActive == 2) {
        this.fetchHotNews();
      } else if (this.tabActive == 4) {
        this.loadNotice();
      } else {
        this.loadCategoriesHonors();
      }
    },
    loadNotice(isFirstDefault) {
      try {
        this.loading(true);
        this.serverParams.columnFilters.searchQuery = this.searchQuery;
        useJwt.post("portal/notices/getAllEffect", this.serverParams).then((response) => {
          var result = response.data;
          if (result.code == 200) {
            this.listNotices = result.result;
            this.totalNotices = result.totalRecords;
            if (isFirstDefault && this.listNotices.length > 0) {
              if (this.listNotices.length == 1) {
                this.currentItem = this.listNotices[0];
                if (this.currentItem.contents && this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                  this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
                }
                this.$bvModal.show("modal-notices-detail-hot");
              } else {
                this.$bvModal.show("modal-hot-notices");
              }
            }
          }
          this.isLoading = false;
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }
    },
    hotNew() {
      try {
        this.loading(true);
        useJwt.get("portal/getconfirm2").then((response) => {
          var result = response.data;
          if (result.code == 200) {
            if (!result.result || result.result.length == 0) {
              this.fetchHotNews(2);
              this.$bvModal.show("modal-hot-new");

            }
          }
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }
    },


    async loadCategories() {
      useJwt.get("portal/getAllCategoriesNew").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          const listChildren = [];
          const self = this;
          result.result.forEach(item => {
            item.text = item.name;
            if (item.level == 0) {
              item.isShow = true;
              self.categoryList.push(item);
            } else {
              listChildren.push(item);
            }
          });
          self.categoryList.forEach(item => {
            item.children = listChildren.filter(function (chi) {
              return chi.parent_id == item.id
            });
          });
        }
        this.isLoading = false;
        this.loading(false);
      });
    },

    async loadCategoriesHonors() {
      this.categoryHonors = [];
      useJwt.get("portal/getAllCategoriesNew?cateType=1").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          const listChildren = [];
          const self = this;
          result.result.forEach(item => {
            item.text = item.name;
            item.isShow = false;
            if (item.level == 0) {
              self.categoryHonors.push(item);
            } else {
              listChildren.push(item);
            }
          });
          self.categoryHonors.forEach(item => {
            item.children = listChildren.filter(function (chi) {
              return chi.parent_id == item.id
            });
          });
        }
        this.isLoading = false;
        this.loading(false);
      });
    },

    detailClick(row) {
      const id = row.id;
      this.loading(true);
      useJwt
          .get("portal/news/" + id)
          .then((response) => {
            if (response.data.code == 200) {
              row.isRead = true;
              this.currentItem = response.data.result;

              if (this.currentItem.effect_date) {
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
              }
              if (this.currentItem.end_effect_date) {
                this.currentItem.end_effect_date = this.formatDate(this.currentItem.end_effect_date);
              }

              if (this.currentItem.contents && this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
              }
            }
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    detailModalShow(row) {
      const id = row.id;
      this.loading(true);
      useJwt
          .get("portal/news/" + id)
          .then((response) => {
            if (response.data.code == 200) {
              row.isRead = true;
              this.currentItem = response.data.result;

              if (this.currentItem.effect_date) {
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
              }
              if (this.currentItem.end_effect_date) {
                this.currentItem.end_effect_date = this.formatDate(this.currentItem.end_effect_date);
              }

              if (this.currentItem.contents && this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
              }
              this.$bvModal.show("modal-new-detail");
            }
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    detailNoticeShow(row) {
      const id = row.id;
      this.loading(true);
      useJwt
          .get("portal/notices/" + id)
          .then((response) => {
            if (response.data.code == 200) {
              row.isRead = true;
              this.currentItem = response.data.result.master;

              // if (this.currentItem.effect_date) {
              //   this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
              // }
              // if (this.currentItem.end_effect_date) {
              //   this.currentItem.end_effect_date = this.formatDate(this.currentItem.end_effect_date);
              // }

              if (this.currentItem.contents && this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
              }
              this.$bvModal.show("modal-notices-detail");
            }
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    isSelected: function (i) {
      return this.currentItem && this.currentItem.id === i;
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    formatDate(v) {
      return moment(v, 'YYYY/MM/DD').format('DD/MM/YYYY')
    },

    async loadEmailConfig() {
      useJwt.get("portal/emailconfig").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          result.result.forEach(item => {
            this.emalConfigs.push(item.email);
          });
        }

        this.isLoading = false;
        this.loading(false);
      });
    },

    showFeedback(itemNew) {
      this.feedbackItem = {};
      this.feedbackItem.new_group_id = itemNew.id;
      if (itemNew.name) {
        this.feedbackItem.newName = itemNew.name;
      } else {
        this.feedbackItem.newName = itemNew.question;
      }
      this.$bvModal.show("modal-feedback");
    },

    async handleFeedbackOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.feedbackItem.contents || this.feedbackItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung góp ý!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        const createParams = {
          id: 0,
          new_group_id: this.feedbackItem.new_group_id,
          contents: this.feedbackItem.contents,
          notes: this.feedbackItem.notes,
          created_at: userName,
          emails: this.emalConfigs.join(','),
          newName: this.feedbackItem.newName,
          type: 0
        };
        this.loading(true);
        const res = await useJwt.post("portal/feedback", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-feedback");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới ý kiến phản hồi!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }

      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới ý kiến phản hồi ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    showSMS(itemNew) {
      this.smsItem = {};
      this.smsItem.ref_id = itemNew.id;
      this.smsItem.newName = itemNew.answer;
      this.$bvModal.show("modal-sms");
    },

    async handleSMSOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.smsItem.phone || this.smsItem.phone.trim().length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số điện thoại nhận SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      if (this.smsItem.phone.indexOf('087') != 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số iTel (bắt đầu bằng 087)!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      if (!this.smsItem.contents || this.smsItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        const createParams = {
          id: 0,
          ref_id: this.smsItem.ref_id,
          contents: this.smsItem.contents.trim(),
          phone: this.smsItem.phone,
          created_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/sms", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-sms");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Gửi sms thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }

      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi gửi sms.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async confirm() {
      try {
        this.loading(true);
        const res = await useJwt.post("portal/HotNew2", {});
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-hot-new");
          this.$bvModal.show('modal-confirm-sucess');
          var self = this;
          setTimeout(function () {
            self.$bvModal.hide("modal-confirm-sucess");
          }, 4000);
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi xác nhận tin Hot",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async confirmNotices() {
      this.$bvModal.show('modal-confirm-sucess-notices');
      this.$bvModal.hide("modal-hot-notices");
      this.$bvModal.hide("modal-notices-detail-hot");
    },
    async uploadFile() {
      try {
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.feedbackItem.file);
        const res = await useJwt.post(`portal/upload`, formData);
        if (res.data.code == 200) {
          this.feedbackItem.file_path = res.data.result;
        }
        this.loading(false);
      } catch (err) {
        this.loading(false);
      }

    },
    async downloadFile(filePath) {
      try {
        const downloadParams = {filePath: filePath};
        const arrFile = filePath.replaceAll('\\', '/').split('/');
        this.loading(true);
        const res = await useJwt.postDownload("portal/download", arrFile[1], downloadParams);
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
    clickTreeItem(id) {
      if (this.item_active_id == id) {
        this.item_active_id = -1;
      } else {
        this.item_active_id = id;
      }
      this.fetchNews();
    },
    loadHonors() {
      try {
        this.serverParams.columnFilters.topicId = this.item_active_id;
        this.serverParams.columnFilters.searchQuick = this.searchQuery;
        this.loading(true);
        useJwt.post("portal/gethonors", this.serverParams)
            .then((response) => {
              if (response.data.code == 200) {
                this.listHonors = response.data.result;
                this.totalRecordHot = response.data.totalRecords;
              } else {
                this.listHonors = [];
                this.totalRecordHot = 0;
              }
              this.isLoading = false;
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } catch (err) {
        this.loading(false);
      }
    },
    noticeClose() {
      this.$bvModal.hide('modal-confirm-sucess-notices');
    },
    /**
     *
     * @param {*} id
     */
    clickTreeItemHonors(id) {
      if (this.item_active_id == id) {
        this.item_active_id = -1;
      } else {
        this.item_active_id = id;
      }
      this.loadHonors();
    },
    async closeModal(id) {
      this.$bvModal.hide(id);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
<style lang="css">
.tree-default {
  margin-top: 14px;
}

/* .cat-new .list-group-item:not(.group-item-active) {
  background-color: unset;
} */

.cat-new .card {
  width: 100%;
  margin-bottom: 0 !important;
}


.cat-new .card-body {
  padding: 1rem !important;
  height: calc(100vh - 245px);
  overflow-y: auto;
  overflow-x: hidden;
}

.new-detail .card-body {
  height: calc(100vh - 200px);
}

.nav-tabs .nav-item {
  position: relative;
  background: #fff;
  border: 1px solid #ccc;
  width: 25%;
  height: 32px;
  line-height: 15px;
}

.nav-tabs .nav-link,
.nav-tabs .nav-item.show .nav-link {
  color: black;
  font-family: 'Times New Roman';
  font-size: 15px;
}

.nav-tabs .nav-link.active {
  background-color: red !important;
  color: white !important;
  height: 30px;
}

.bt-tonggle-collspan {
  line-height: 40px;
  vertical-align: middle;
  align-items: center;
  padding-left: 0.2rem !important;
  padding: 10px !important;
  line-height: 30px;
}

.bt-tonggle-collspan .icon-img {
  content: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAFCAYAAACeuGYRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAChSURBVHgBdY69DcIwEIWfHXoudHQnoGAMRmGDZAOSCQgVLRuQDYANYAFksQAuEUIxz4WlCJGTTvfzvnu6bKFaylj2k1xeT+9vGAhyq1xky5zaEdCagCsCDnPVozL68JIz96cQEFMz4GySOFNd83jDVlnrj0VDw5JgEXXW6v5wu9ibvitNxQIFj6q0I9x0FrVzzqed+fd/fOndoSDcEr786l+DyzUZvfQQawAAAABJRU5ErkJggg==');
}

.bt-tonggle-expand {
  vertical-align: middle;
  align-items: center;
  line-height: 30px;
  height: 30px;
  width: 30px;
  padding: 10px !important;
  padding-left: 0.2rem !important;
}

.bt-tonggle-expand .icon-img {
  content: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAFCAYAAACeuGYRAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAACBSURBVChTY/iPBZw4ceJ/c2PT/yePH0NFUAGKpo8fP4IVK8srwPHECRPA4sgArmn+3Hn/DXX1wHhifz9Y4cS+frBGe2ub/2tWr4aqBGq6dvXqfx9PL7BkVEQEhpMeA/kZaWlg+bLiErA8w7y5c8GCJ44fhyrDDtauWQM2fP7cuf8B+j/RB1rMEZUAAAAASUVORK5CYII=');
}

.cat-new .list-group {
  height: calc(100vh - 385px);
}

.nav-tabs .nav-link {
  border: none;
  padding: 0.61rem;
  border-radius: 0;
}

.item-sub-text {
  color: #000 !important;
  font-size: 13px;
  font-family: 'Times New Roman';
  text-align: left;
  cursor: pointer;
}

.item-chi-active .tree-item-text-chi,
.item-sub-active .item-sub-text {
  color: white !important;
}

.item-sub-active .div-item-text {
  background-color: #FF5A5A;
  border-radius: 10px;
  padding-left: 0.6rem;
  width: 90%;
  margin: 0 5%;
}

.tree-item {
  line-height: 26px;
  min-height: 26px;
  text-align: left;
  padding-left: 0.7rem;
  cursor: pointer;
}

.tree-item-chi {
  line-height: 24px;
  min-height: 24px;
  text-align: left;
  padding-left: 0.5rem;
  cursor: pointer;
}

.group-item-active {
  background-color: #FF5A5A;
  border-radius: 10px;
  margin: 0 1rem;
  padding-left: 1rem;
}


.list-group.list-group-circle .list-group-item:hover {
  background-color: #FF5A5A;
  border-radius: 10px;
  opacity: 0.8;
  color: white;
}

.list-group .list-group-item {
  line-height: 7px;
  min-height: 26px;
}

.item-chi-active {
  background-color: #FF5A5A;
  border-radius: 10px;
  margin: 0 0.7rem;
  padding-left: 0.5rem !important;
  min-height: 28px;
}

.tree-item-text,
.tree-item-text-chi {
  color: #000 !important;
  font-size: 13px;
  font-weight: bold;
  font-family: 'Times New Roman';
  text-align: left;
  cursor: pointer;
}

.item-chi-active .tree-item-text-chi {
  color: white !important;
}

.title-cat {
  background: #FF5A5A;
  height: 32px;
  text-align: center;
  vertical-align: middle;
  line-height: 32px;
  font-family: 'Times New Roman';
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #fff;
  width: 92%;
  margin: 0 auto;
}

.no-data label {
  font-size: 25px;
  font-weight: bold;
  color: #000;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.use-new {
  padding: 10px 15px;
}

.use-new label {
  line-height: 50px;
  font-size: 1rem;
}

.cat-new {
  font-family: 'Times New Roman';
  color: #000000;
  margin-top: -15px;
}

.cat-sub .card-body {
  background: rgba(217, 217, 217, 0.1);
}

.cat-new .text-body:not(.group-item-active, .active) {
  font-family: 'Times New Roman';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #000000 !important;
}

.question-content-break {
  min-height: 330px;
  white-space: break-spaces;
  line-height: 2.5rem;
  text-align: left;
}

.input-group-merge {
  cursor: pointer;
}


.list-group-item > span {
  cursor: pointer;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.status-1 {
  background-color: #6DC957;
  padding: 0 10px;
  color: #000;
  font-size: 13px;
}

.status-2 {
  background-color: #FF5A5A;
  padding: 2px 10px;
  color: #000;
  font-size: 13px;
}

.hr-bottom {
  border-bottom: 1px solid #000;
}

.detail-tile {
  background-color: #FF5A5A;
  color: white;
  font-weight: 700;
  font-size: 15px;
  height: 33px;
  line-height: 33px;
  margin-top: 4px;
  margin-bottom: 10px;
  padding: 0 10px;
}

.not-padding {
  padding: 0 !important;
}

.not-padding-r {
  padding-right: 0 !important;
}

.phone-re {
  display: inline-block;
  width: 200px;
  margin-left: 20px;
  border: 1px solid #ddd;
  height: 30px;
  border-radius: 3px;
}

input:focus-visible {
  outline: none !important;
  border: 1px solid #ed1f24;
}

.confirm-text {
  color: #000;
  font-size: 13px !important;
}

.img-btn {
  width: 60px;
  cursor: pointer;
  margin: 0 20px;
}

.input-group-merge {
  cursor: pointer;
}

.list-group.list-group-circle .list-group-item:after {
  left: 10px;
  background-image: none;
}

.list-group.list-group-circle .list-group-item {
  padding-left: 0.5rem;
  text-align: left;
  cursor: pointer;
  border-radius: 10px;
  height: 26px;
  line-height: 7px;
}

.question-content img {
  max-width: 100% !important;
}

.search-new {
  height: 30px;
}

.search-new::placeholder {
  font-family: 'Times New Roman';
  font-style: italic;
  font-weight: 400;
  font-size: 13px;
  color: #000;
}

.input-group-text,
.form-control {
  color: #000;
  border-radius: 0.8rem;
}

.modal-xl {
  max-width: 70% !important;
  margin: 0 auto;
  padding-top: 4rem;
}

.group-item-active {
  background-color: #FF5A5A;
  border-radius: 10px;
  color: #fff !important;
  margin-left: 0px;
}


.border-lr {
  border-left: 1px solid #ebe9f1;
  border-right: 1px solid #ebe9f1;
}

.border-left {
  border-left: 2px solid #ccc;
}

.font-bold {
  font-weight: bold;
}

.margin-b {
  margin-bottom: 0 !important;
}

#modal-hot-new .modal-content {
  border: 2px solid #FF5A5A;
  border-radius: 15px;
}

.hot-new-content-popup {
  display: flex;
  width: 100%;
  height: 650px;
  padding: 50px;
}

.btn-confirm {
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}

.btn-close {
  font-size: 15px;
  font-family: 'Times New Roman';
  font-style: normal;
  min-width: 120px;
  margin: 10px 0;
  padding: 10px 0;
}

.parent-item {
  background-color: #ede5e5;
  border-radius: 8px;
  padding: 0 5px;
  margin: 4px 0;
}

.content-cat .vgt-table td,
.content-cat .vgt-table th {
  max-width: 300px;
  font-size: 13px !important;
  color: #000 !important;
  height: 65px !important;
  font-size: 18px !important;
  color: #000;
  padding: 0 8px !important;
}

.content-cat table.vgt-table,
.content-cat .vgt-table th {
  border: none !important;
  text-align: left;
  padding-left: 50px !important;
}

.content-cat .vgt-table.striped tbody tr:nth-of-type(odd) {
  background-color: #FEEAEB !important;
  border-radius: 10px;
}

.vgt-fixed-header {
  position: absolute;
  z-index: 10;
  width: 100%;
  overflow-x: auto;
}

.tree-disabled .tree-checkbox {
  display: none !important;
}

.content-cat .vgt-table tbody tr {
  border: 2px solid #FF5A5A !important;
  border-radius: 15px !important;
}

#modal-confirm-sucess-notices .modal-content {
  width: 800px;
  background-color: transparent !important;
}

.confirm-notice {
  cursor: pointer;
}

#modal-confirm-sucess .modal,
#modal-confirm-sucess .modal-content {
  width: 800px;
  background: transparent;
}

.header-status .form-group {
  margin-bottom: 0.1rem !important;
  margin-top: -0.5rem;
}

@media only screen and (max-width: 1600px) {

  .bt-tonggle-collspan,
  .bt-tonggle-expand {
    padding: 10px 0 !important;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

table th,
table td {
  border: 1px solid #ddd;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-top-style: solid;
  border-right-style: solid;
  border-bottom-style: solid;
  border-left-style: solid;
  border-top-color: rgb(221, 221, 221);
  border-right-color: rgb(221, 221, 221);
  border-bottom-color: rgb(221, 221, 221);
  border-left-color: rgb(221, 221, 221);
  border-image-source: initial;
  border-image-slice: initial;
  border-image-width: initial;
  border-image-outset: initial;
  border-image-repeat: initial;
  padding: 2px;
}

.honors-row {
  display: flex;
  flex-direction: row;
}

.honors-item {
  width: 280px;
  display: flex;
  text-align: center;
  justify-content: center;
  font-size: 18px;
}

.honors-item-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 30px;
}

.honors-item-content div {
  margin: 5px 0;
  display: flex;
  width: 100%;
  padding: 10px;
}

.prize, .full-name {
  font-weight: bold;
}

.honors-item-content .prize {
  text-transform: uppercase;
  background-color: #f8cecc;
  border-radius: 5px;
  border: 1px solid #d18582;
  justify-content: center;
}

.honors-item-content .full-name {
  background-color: #dae8fc;
  border-radius: 5px;
  border: 1px solid #a6bbd9;
  justify-content: center;
}

.honors-item-content .img-path img {
  max-width: 260px;
  width: 100%;
  height: auto;
  justify-content: center;
}

.honors-item-content .channel {
  background-color: #d5e8d4;
  border-radius: 5px;
  border: 1px solid #a1c68e;
  justify-content: center;
}

.honors-item-content .point {
  background-color: #fbe9b6;
  border-radius: 5px;
  border: 1px solid #e4cb81;
  justify-content: center;
}

.honors-item-content .parner {
  background-color: #fdc892;
  border-radius: 5px;
  border: 1px solid #e4b648;
  justify-content: center;
}
</style>
